export const Paws: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    id="Camada_1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="-1 -1 83 35"
    {...props}
  >
    <defs>
      <style>
        {".cls-1{fill:#fffff;}.cls-2{opacity:.125;}.cls-3{fill:#F3E5AB;}"}
      </style>
    </defs>
    <g className="cls-2">
      <path
        className="cls-1"
        d="M13.17,8.32s-.05.06-.06.07c0,.01.01.04,0,.05-.01.02-.05,0-.06,0,0,0,.01.15-.03.19-.02.01-.08-.02-.14.03-.02.02.01.07-.03.1-.02.02-.05.01-.06.02-.02.01-.01.04-.03.06-.02.02-.06.01-.09.03s-.03.06-.05.09-.05.02-.07.04c0,0,.01.03,0,.05-.02.04-.06.05-.08.08,0,.01.01.04,0,.07-.03.1-.13.15-.23.15-.04,0-.08-.04-.11-.03-.06.01.04.08.04.09,0,.01-.17.18-.19.21-.02.02-.03.05-.05.07-.05.05-.15.1-.22.1-.16,0-.26-.11-.34-.25-.09-.15-.01-.34.08-.48.02-.04.1-.1.1-.1,0-.03-.04-.05-.04-.08,0-.02.02-.04.03-.06,0-.02-.02-.05,0-.06.02-.02.06-.03.08-.04.01-.01-.03-.06,0-.09s.11,0,.13-.06c0-.02-.08-.15-.08-.16,0-.01.06-.01.07-.06,0-.06-.04-.13-.04-.18,0-.03.02-.14.01-.15,0-.02-.08-.06-.08-.12,0-.06.13-.17.16-.21.02-.03-.01-.07,0-.08.02-.01.04,0,.06-.01.02-.01.03-.05.06-.07.05-.04.11-.01.17-.01.12,0,.2,0,.31.03.1.01.17-.08.26-.09.04,0,.07.03.08.03.02,0,.18-.16.23-.19.13-.09.24-.11.39-.09s.35.14.33.31c0,.04-.04.07-.04.09,0,.03.03.05.03.06,0,0-.03.03-.04.06-.02.05.02.1.02.11,0,.01-.12.14-.14.17-.02-.01-.03,0-.05.02-.03.02-.06.03-.08.05,0,0-.02.01-.02.02-.03,0-.03.03-.09-.03-.04-.05-.05-.13-.1-.02,0,.02.02.13.03.16-.03.02-.03.04-.05.06-.01.02-.04.01,0,.06Z"
      />
      <path
        className="cls-1"
        d="M10.22,5.97c.05.03.08.08.14.09.03.05.07.09.12.12.02.06.08.12.12.17.03.03.1.08.11.11,0,.02-.04.05-.04.08,0,.02.08.15.09.15.06,0,.03-.22.11-.11,0,.03.05.14.08.16v.03s.04.05.05.07c-.03.01-.03.03,0,.04,0,.03,0,.09.03.11.03.02.06-.02.06-.02.04,0,0,.05,0,.07,0,.04.04.09.03.13,0,0-.02.01-.02.02-.04.04.01.08,0,.13,0,.01-.05.08-.05.09,0,0-.06-.03-.07-.03-.02-.03.03-.17-.01-.2-.12,0-.09.05-.12.08,0,0-.03-.02-.03-.01-.06.03,0,.1,0,.11,0,0-.09.06-.1.06-.01,0-.18-.05-.2-.07-.07.1-.14.13-.25.15-.29.05-.65-.22-.82-.44-.11-.15-.27-.43-.3-.61s.05-.44.23-.52c.12-.05.43-.04.55,0,.04.01.11.06.14.06.04,0,.07-.06.17,0Z"
      />
      <path
        className="cls-1"
        d="M10.49,6.13c-.06-.06-.06-.13-.1-.19-.09-.13-.19-.15-.23-.32-.03-.11,0-.46.06-.56.06-.11.16-.17.28-.19.14-.01.21.07.32.12.15.06.23.05.41.14.03.02.09.01.12.04.02.02.16.2.18.23.03.05.06.18.06.24,0,.05-.06.1-.06.11,0,.01.08.17.08.24,0,.04-.03.08,0,.12.03.07.1.09.06.19-.03.08-.09.06-.13,0-.02.02.01.05,0,.07,0,.02-.06.03-.07.04,0,.01.06.06.02.09-.06.05-.1-.02-.13,0s-.06.08-.09.1c-.04.02-.07,0-.1,0-.03.02-.05.08-.09.09-.04-.03-.04-.08-.07-.13.02-.05,0-.05-.04-.07-.06-.03-.05,0-.07,0-.07-.01-.09-.07-.13-.1-.1-.09-.18-.17-.27-.27Z"
      />
      <path
        className="cls-1"
        d="M10.97,7.78c-.03.15.02.29,0,.41,0,.05-.05.09-.05.13,0,.09.06.2.08.27,0,0,.02.12.02.12,0,.02-.14.26-.16.28-.06.05-.1,0-.13.01-.02,0-.02.05-.05.06-.02,0-.04-.01-.06-.01-.14.02-.23.03-.37.02-.23,0-.27-.27-.36-.44-.06-.12-.12-.16-.14-.31-.03-.17.09-.49.23-.59.04-.03.15-.1.2-.13.06-.04.22-.13.29-.11.05.01.07.06.18.06.02,0,.04-.02.05-.02.03,0,.05.09.06.09,0,0,.07-.04.07-.04.02,0,.02.05.03.06-.01,0-.08,0-.06.02.02.02.06.02.08,0,0,0,.01.02.02.02.02.03.05.05.07.08Z"
      />
      <path
        className="cls-1"
        d="M12.46,5.51s.11-.04.15-.03c.06,0,.13.09.19.12.04.02.13.03.16.06.02.02.02.05.05.07.02.02.07,0,.09.03,0,0-.02.03-.01.03.02.03.11.09.14.14.09.12.1.27.09.42,0,.06-.04.19-.07.24-.04.07-.22.26-.29.29-.05.02-.08-.02-.13-.01-.05,0-.13.06-.17.04-.03-.01-.05-.05-.07-.07-.02,0-.06,0-.09,0-.04-.01-.19-.1-.23-.12-.1-.07-.2-.21-.09-.31-.02-.04-.03,0-.04,0-.03,0-.09-.13-.09-.16,0-.03.02-.05.02-.08-.03-.17.01-.15.05-.28,0-.02,0-.06,0-.09.02-.14.02-.23.19-.28.07-.02.13.01.18.01Z"
      />
      <path
        className="cls-1"
        d="M11.14,7.35c.01.06.1.11.04.17l-.04-.05s.03.08.05.12c.03.07,0,.15-.06.21-.05-.02-.02-.09-.03-.11-.02-.04-.12-.05-.04-.1l.04.03s-.04-.27.03-.27Z"
      />
      <path
        className="cls-1"
        d="M11.75,5.81s0,.15,0,.17c-.02.03-.03,0-.04-.01-.03-.03-.02-.06-.07-.01-.03-.07.08-.13.08-.17l.04.03Z"
      />
      <path
        className="cls-1"
        d="M13.22,8.2s-.04-.14-.03-.16c.05-.11.06-.02.1.02-.05.02,0,.06-.04.08-.01,0-.02-.03-.04,0l.06.05s-.04.02-.05.02Z"
      />
      <path
        className="cls-1"
        d="M10.22,5.97v-.07s.03.04.05.05c0,0,.13-.01.04.02.03.02.04.07.05.08-.06,0-.08-.06-.14-.09Z"
      />
      <path
        className="cls-1"
        d="M11.71,5.78s-.02-.02-.01-.03c.02-.02.06-.04.08-.06.03,0,.04.13-.02.08,0,0,0,.02,0,.04l-.04-.03Z"
      />
      <path
        className="cls-1"
        d="M11.21,8.25s-.1-.07-.09-.08c.13-.07.04.02.09.08Z"
      />
      <path className="cls-1" d="M11.14,7.9l.05.08c-.08.06-.13-.02-.05-.08Z" />
      <path
        className="cls-1"
        d="M11.12,7.16s.04,0,.05,0,0-.02,0-.02c0-.03.04-.02.04-.02,0,.01-.07.17-.11.06,0,0,.02-.02.02-.02Z"
      />
      <path
        className="cls-1"
        d="M10.9,7.7s.08.03.07.08c-.02-.03-.05-.05-.07-.08Z"
      />
      <path className="cls-1" d="M11.82,5.79s0,.09-.02.1c0-.02-.02-.1.02-.1Z" />
      <path
        className="cls-1"
        d="M10.86,7.65s.01.02.02.02c-.02.02-.06.02-.08,0-.02-.02.05-.02.06-.02Z"
      />
      <path
        className="cls-1"
        d="M10.99,6.58s-.05-.04-.04-.07c.03.02.06.02.04.07Z"
      />
      <path
        className="cls-1"
        d="M13.17,8.26s.02.03,0,.06c-.05-.04-.02-.03,0-.06Z"
      />
      <path
        className="cls-1"
        d="M13.52,8s-.01.07-.05.02c.01,0,.03-.03.05-.02Z"
      />
      <path
        className="cls-1"
        d="M10.96,6.73s.03,0,.03.01c0,0-.02.01-.02.02v-.03Z"
      />
      <path
        className="cls-1"
        d="M11,6.83c.03.05,0,.03,0,.04-.02-.02-.02-.03,0-.04Z"
      />
      <path
        className="cls-1"
        d="M13.39,8.07c.05.08-.02.02-.02.02,0,0,.02-.01.02-.02Z"
      />
      <path className="cls-1" d="M11.84,5.94h-.01s-.02-.05.01,0Z" />
      <path
        className="cls-1"
        d="M21.82,12.8s-.05.06-.06.07c0,.01.01.04,0,.05-.01.02-.05,0-.06,0,0,0,.01.15-.03.19-.02.01-.08-.02-.14.03-.02.02.01.07-.03.1-.02.02-.05.01-.06.02-.02.01-.01.04-.03.06-.02.02-.06.01-.09.03s-.03.06-.05.09-.05.02-.07.04c0,0,.01.03,0,.05-.02.04-.06.05-.08.08,0,.01.01.04,0,.07-.03.1-.13.15-.23.15-.04,0-.08-.04-.11-.03-.06.01.04.08.04.09,0,.01-.17.18-.19.21-.02.02-.03.05-.05.07-.05.05-.15.1-.22.1-.16,0-.26-.11-.34-.25-.09-.15-.01-.34.08-.48.02-.04.1-.1.1-.1,0-.03-.04-.05-.04-.08,0-.02.02-.04.03-.06,0-.02-.02-.05,0-.06.02-.02.06-.03.08-.04.01-.01-.03-.06,0-.09s.11,0,.13-.06c0-.02-.08-.15-.08-.16,0-.01.06-.01.07-.06,0-.06-.04-.13-.04-.18,0-.03.02-.14.01-.15,0-.02-.08-.06-.08-.12,0-.06.13-.17.16-.21.02-.03-.01-.07,0-.08.02-.01.04,0,.06-.01.02-.01.03-.05.06-.07.05-.04.11-.01.17-.01.12,0,.2,0,.31.03.1.01.17-.08.26-.09.04,0,.07.03.08.03.02,0,.18-.16.23-.19.13-.09.24-.11.39-.09s.35.14.33.31c0,.04-.04.07-.04.09,0,.03.03.05.03.06,0,0-.03.03-.04.06-.02.05.02.1.02.11,0,.01-.12.14-.14.17-.02-.01-.03,0-.05.02-.03.02-.06.03-.08.05,0,0-.02.01-.02.02-.03,0-.03.03-.09-.03-.04-.05-.05-.13-.1-.02,0,.02.02.13.03.16-.03.02-.03.04-.05.06-.01.02-.04.01,0,.06Z"
      />
      <path
        className="cls-1"
        d="M18.87,10.45c.05.03.08.08.14.09.03.05.07.09.12.12.02.06.08.12.12.17.03.03.1.08.11.11,0,.02-.04.05-.04.08,0,.02.08.15.09.15.06,0,.03-.22.11-.11,0,.03.05.14.08.16v.03s.04.05.05.07c-.03.01-.03.03,0,.04,0,.03,0,.09.03.11.03.02.06-.02.06-.02.04,0,0,.05,0,.07,0,.04.04.09.03.13,0,0-.02.01-.02.02-.04.04.01.08,0,.13,0,.01-.05.08-.05.09,0,0-.06-.03-.07-.03-.02-.03.03-.17-.01-.2-.12,0-.09.05-.12.08,0,0-.03-.02-.03-.01-.06.03,0,.1,0,.11,0,0-.09.06-.1.06-.01,0-.18-.05-.2-.07-.07.1-.14.13-.25.15-.29.05-.65-.22-.82-.44-.11-.15-.27-.43-.3-.61s.05-.44.23-.52c.12-.05.43-.04.55,0,.04.01.11.06.14.06.04,0,.07-.06.17,0Z"
      />
      <path
        className="cls-1"
        d="M19.13,10.61c-.06-.06-.06-.13-.1-.19-.09-.13-.19-.15-.23-.32-.03-.11,0-.46.06-.56.06-.11.16-.17.28-.19.14-.01.21.07.32.12.15.06.23.05.41.14.03.02.09.01.12.04.02.02.16.2.18.23.03.05.06.18.06.24,0,.05-.06.1-.06.11,0,.01.08.17.08.24,0,.04-.03.08,0,.12.03.07.1.09.06.19-.03.08-.09.06-.13,0-.02.02.01.05,0,.07,0,.02-.06.03-.07.04,0,.01.06.06.02.09-.06.05-.1-.02-.13,0s-.06.08-.09.1c-.04.02-.07,0-.1,0-.03.02-.05.08-.09.09-.04-.03-.04-.08-.07-.13.02-.05,0-.05-.04-.07-.06-.03-.05,0-.07,0-.07-.01-.09-.07-.13-.1-.1-.09-.18-.17-.27-.27Z"
      />
      <path
        className="cls-1"
        d="M19.62,12.26c-.03.15.02.29,0,.41,0,.05-.05.09-.05.13,0,.09.06.2.08.27,0,0,.02.12.02.12,0,.02-.14.26-.16.28-.06.05-.1,0-.13.01-.02,0-.02.05-.05.06-.02,0-.04-.01-.06-.01-.14.02-.23.03-.37.02-.23,0-.27-.27-.36-.44-.06-.12-.12-.16-.14-.31-.03-.17.09-.49.23-.59.04-.03.15-.1.2-.13.06-.04.22-.13.29-.11.05.01.07.06.18.06.02,0,.04-.02.05-.02.03,0,.05.09.06.09,0,0,.07-.04.07-.04.02,0,.02.05.03.06-.01,0-.08,0-.06.02.02.02.06.02.08,0,0,0,.01.02.02.02.02.03.05.05.07.08Z"
      />
      <path
        className="cls-1"
        d="M21.1,9.99s.11-.04.15-.03c.06,0,.13.09.19.12.04.02.13.03.16.06.02.02.02.05.05.07.02.02.07,0,.09.03,0,0-.02.03-.01.03.02.03.11.09.14.14.09.12.1.27.09.42,0,.06-.04.19-.07.24-.04.07-.22.26-.29.29-.05.02-.08-.02-.13-.01-.05,0-.13.06-.17.04-.03-.01-.05-.05-.07-.07-.02,0-.06,0-.09,0-.04-.01-.19-.1-.23-.12-.1-.07-.2-.21-.09-.31-.02-.04-.03,0-.04,0-.03,0-.09-.13-.09-.16,0-.03.02-.05.02-.08-.03-.17.01-.15.05-.28,0-.02,0-.06,0-.09.02-.14.02-.23.19-.28.07-.02.13.01.18.01Z"
      />
      <path
        className="cls-1"
        d="M19.78,11.83c.01.06.1.11.04.17l-.04-.05s.03.08.05.12c.03.07,0,.15-.06.21-.05-.02-.02-.09-.03-.11-.02-.04-.12-.05-.04-.1l.04.03s-.04-.27.03-.27Z"
      />
      <path
        className="cls-1"
        d="M20.39,10.29s0,.15,0,.17c-.02.03-.03,0-.04-.01-.03-.03-.02-.06-.07-.01-.03-.07.08-.13.08-.17l.04.03Z"
      />
      <path
        className="cls-1"
        d="M21.86,12.68s-.04-.14-.03-.16c.05-.11.06-.02.1.02-.05.02,0,.06-.04.08-.01,0-.02-.03-.04,0l.06.05s-.04.02-.05.02Z"
      />
      <path
        className="cls-1"
        d="M18.87,10.45v-.07s.03.04.05.05c0,0,.13-.01.04.02.03.02.04.07.05.08-.06,0-.08-.06-.14-.09Z"
      />
      <path
        className="cls-1"
        d="M20.35,10.26s-.02-.02-.01-.03c.02-.02.06-.04.08-.06.03,0,.04.13-.02.08,0,0,0,.02,0,.04l-.04-.03Z"
      />
      <path
        className="cls-1"
        d="M19.86,12.73s-.1-.07-.09-.08c.13-.07.04.02.09.08Z"
      />
      <path
        className="cls-1"
        d="M19.78,12.38l.05.08c-.08.06-.13-.02-.05-.08Z"
      />
      <path
        className="cls-1"
        d="M19.77,11.64s.04,0,.05,0,0-.02,0-.02c0-.03.04-.02.04-.02,0,.01-.07.17-.11.06,0,0,.02-.02.02-.02Z"
      />
      <path
        className="cls-1"
        d="M19.55,12.18s.08.03.07.08c-.02-.03-.05-.05-.07-.08Z"
      />
      <path
        className="cls-1"
        d="M20.46,10.27s0,.09-.02.1c0-.02-.02-.1.02-.1Z"
      />
      <path
        className="cls-1"
        d="M19.51,12.13s.01.02.02.02c-.02.02-.06.02-.08,0-.02-.02.05-.02.06-.02Z"
      />
      <path
        className="cls-1"
        d="M19.64,11.06s-.05-.04-.04-.07c.03.02.06.02.04.07Z"
      />
      <path
        className="cls-1"
        d="M21.81,12.74s.02.03,0,.06c-.05-.04-.02-.03,0-.06Z"
      />
      <path
        className="cls-1"
        d="M22.16,12.48s-.01.07-.05.02c.01,0,.03-.03.05-.02Z"
      />
      <path
        className="cls-1"
        d="M19.6,11.21s.03,0,.03.01c0,0-.02.01-.02.02v-.03Z"
      />
      <path
        className="cls-1"
        d="M19.65,11.31c.03.05,0,.03,0,.04-.02-.02-.02-.03,0-.04Z"
      />
      <path
        className="cls-1"
        d="M22.04,12.55c.05.08-.02.02-.02.02,0,0,.02-.01.02-.02Z"
      />
      <path className="cls-1" d="M20.48,10.42h-.01s-.02-.05.01,0Z" />
      <path
        className="cls-1"
        d="M29.89,9.13s-.07-.03-.09-.03c-.01,0-.03.03-.05.02-.02,0-.02-.05-.02-.05,0,0-.14.06-.19.03-.02-.01,0-.08-.07-.12-.03-.02-.06.03-.11,0-.02-.02-.03-.04-.04-.05-.02-.01-.05,0-.07,0-.03-.01-.03-.06-.06-.08s-.07,0-.1-.02-.04-.04-.05-.05c0,0-.02.02-.04.02-.04,0-.07-.04-.1-.05-.01,0-.04.02-.06.02-.1,0-.19-.08-.21-.18,0-.03.01-.09,0-.11-.03-.05-.06.07-.07.07-.01,0-.22-.11-.26-.12-.03-.01-.06,0-.08-.02-.06-.03-.14-.11-.16-.18-.04-.15.03-.29.14-.39.12-.13.32-.11.48-.06.04.01.12.06.13.06.03,0,.04-.05.07-.06.02,0,.05.01.07,0,.02,0,.04-.03.05-.02.03.01.04.05.06.06.01,0,.05-.04.09-.02s.03.11.1.1c.02,0,.12-.12.13-.12.01,0,.03.06.07.05.06-.02.11-.07.16-.09.02-.01.14-.03.15-.03.01,0,.03-.09.09-.11.06-.02.2.08.25.09.04.01.06-.03.07-.02.02.01.02.04.03.05.02.02.06.02.08.04.05.04.05.11.06.16.03.11.05.19.07.31.02.1.12.14.16.22.02.04,0,.08,0,.09.01.02.21.13.25.16.12.1.17.2.2.35s-.03.38-.2.4c-.04,0-.07-.02-.09-.01-.03,0-.04.05-.05.05,0,0-.04-.02-.07-.02-.05,0-.09.05-.1.05-.01,0-.16-.07-.2-.09,0-.02-.02-.03-.03-.04-.02-.02-.05-.04-.07-.06,0,0-.02-.01-.03-.02,0-.03-.04-.02,0-.09.03-.05.11-.09,0-.1-.02,0-.12.06-.15.08-.03-.02-.04-.02-.07-.03-.02,0-.02-.03-.05.02Z"
      />
      <path
        className="cls-1"
        d="M31.28,5.62c-.01.06-.05.1-.04.16-.03.04-.06.1-.08.15-.05.03-.09.11-.13.17-.02.04-.04.12-.07.14-.02.01-.06-.03-.09-.01-.02,0-.12.12-.12.13.01.06.22-.04.14.07-.03,0-.12.09-.13.12l-.03.02s-.04.05-.06.06c-.02-.02-.03-.02-.04,0-.03,0-.08.03-.09.06,0,.03.04.05.04.05,0,.04-.05.01-.07.02-.03.01-.07.06-.12.07,0,0-.02-.01-.03-.02-.04-.02-.07.03-.13.03-.01,0-.1-.02-.1-.03,0,0,0-.07,0-.07.02-.02.17-.02.19-.07-.03-.12-.08-.07-.11-.09,0,0,0-.03,0-.04-.05-.05-.09.03-.11.02,0,0-.08-.07-.09-.08,0-.01,0-.19,0-.21-.11-.04-.16-.09-.22-.19-.14-.26.02-.69.18-.91.11-.15.33-.38.5-.46s.44-.08.57.07c.08.1.16.4.17.53,0,.05-.03.13-.02.15,0,.04.08.05.05.16Z"
      />
      <path
        className="cls-1"
        d="M31.2,5.92c.04-.07.1-.09.15-.15.1-.12.08-.22.24-.31.1-.06.44-.13.55-.1.12.03.21.1.26.22.05.13,0,.22-.02.34-.02.16.02.23-.01.43,0,.04.01.09,0,.13-.01.02-.15.21-.17.24-.04.04-.16.11-.21.13-.05.01-.11-.03-.12-.03-.01,0-.14.12-.21.15-.04.01-.08,0-.12.03-.06.05-.06.12-.17.11-.09,0-.08-.07-.03-.13-.02-.01-.04.02-.07.02-.03,0-.05-.05-.06-.05-.01,0-.04.07-.08.05-.07-.05,0-.1-.03-.13s-.09-.03-.12-.06c-.03-.03-.02-.07-.04-.1-.03-.03-.09-.03-.12-.06.02-.05.07-.07.1-.1.06,0,.05-.02.06-.06.01-.06-.01-.05-.01-.06,0-.07.04-.1.06-.15.05-.12.11-.23.18-.34Z"
      />
      <path
        className="cls-1"
        d="M29.76,6.87c-.16.01-.27.11-.4.12-.06,0-.1-.02-.14-.01-.09.02-.17.12-.24.16,0,0-.11.05-.11.05-.02,0-.29-.06-.31-.07-.07-.04-.03-.1-.05-.12-.01-.01-.05,0-.07-.03-.01-.01,0-.04,0-.06-.06-.13-.09-.21-.13-.35-.06-.23.18-.34.31-.47.1-.09.12-.16.25-.22.15-.07.49-.06.63.04.04.03.14.12.18.15.05.05.19.17.19.24,0,.05-.03.09,0,.19,0,.02.03.03.03.04,0,.03-.07.07-.07.08,0,0,.06.05.06.06,0,.02-.04.04-.05.04,0-.01-.03-.08-.04-.05-.02.03,0,.06.02.08,0,0-.01.02-.02.03-.02.03-.04.06-.06.09Z"
      />
      <path
        className="cls-1"
        d="M32.37,7.63s.07.1.07.14c0,.06-.05.16-.06.22,0,.05.01.13,0,.17-.01.03-.04.04-.05.07,0,.02.01.07,0,.09,0,0-.03-.01-.04,0-.02.02-.05.13-.09.18-.09.12-.23.17-.37.2-.05.01-.19.02-.25,0-.08-.02-.31-.13-.36-.2-.03-.05,0-.08-.03-.13-.02-.04-.09-.11-.09-.15,0-.03.04-.06.04-.09,0-.02-.02-.05-.02-.09,0-.04.04-.21.05-.26.03-.12.14-.25.27-.18.03-.03,0-.03,0-.04,0-.03.09-.12.13-.14.02,0,.05,0,.08,0,.15-.08.15-.03.28-.04.02,0,.05-.03.08-.03.14-.03.23-.05.33.1.04.06.02.12.04.18Z"
      />
      <path
        className="cls-1"
        d="M30.22,6.91c-.06.03-.07.13-.15.09l.03-.05s-.06.05-.1.09c-.06.05-.15.04-.22,0,0-.05.08-.05.09-.06.03-.03.02-.13.08-.07v.05c.02-.06.23-.12.26-.05Z"
      />
      <path
        className="cls-1"
        d="M31.87,7.04s-.15.05-.17.04c-.04,0,0-.03,0-.05.02-.04.05-.04-.01-.07.06-.05.15.04.19.03v.05Z"
      />
      <path
        className="cls-1"
        d="M30.01,9.14s.13-.08.15-.08c.12.02.04.05,0,.1-.04-.04-.06.02-.09-.02,0-.01.02-.03,0-.04l-.03.07s-.03-.04-.03-.04Z"
      />
      <path
        className="cls-1"
        d="M31.28,5.62h.06s-.03.02-.03.04c0,.01.05.12-.01.04,0,.04-.05.06-.06.07,0-.06.03-.1.04-.16Z"
      />
      <path
        className="cls-1"
        d="M31.88,6.99s0-.03.03-.02c.03,0,.06.04.08.05,0,.03-.12.08-.08,0,0,0-.02.01-.04.01v-.05Z"
      />
      <path
        className="cls-1"
        d="M29.38,7.24s.04-.11.05-.11c.11.11,0,.05-.05.11Z"
      />
      <path
        className="cls-1"
        d="M29.69,7.07l-.06.07c-.08-.06-.02-.13.06-.07Z"
      />
      <path
        className="cls-1"
        d="M30.39,6.83s0,.04.02.05.01-.01.02-.01c.03,0,.04.03.03.04,0,.01-.19-.02-.09-.09,0,0,.02.01.03.02Z"
      />
      <path
        className="cls-1"
        d="M29.82,6.78c.05.02,0,.09-.06.09.02-.03.04-.06.06-.09Z"
      />
      <path
        className="cls-1"
        d="M31.91,7.1s-.08.03-.1.01c.02-.01.09-.05.1-.01Z"
      />
      <path
        className="cls-1"
        d="M29.85,6.73s-.01.02-.02.03c-.02-.02-.04-.05-.02-.08.01-.02.04.04.04.05Z"
      />
      <path
        className="cls-1"
        d="M30.92,6.54s.02-.06.06-.06c0,.04,0,.06-.06.06Z"
      />
      <path
        className="cls-1"
        d="M29.94,9.11c-.03.06-.02.03-.05.02.03-.06.03-.03.05-.02Z"
      />
      <path
        className="cls-1"
        d="M30.29,9.37s-.07,0-.03-.04c.01.01.04.02.03.04Z"
      />
      <path
        className="cls-1"
        d="M30.76,6.55s0,.03,0,.03c0,0-.02-.02-.03-.02l.03-.02Z"
      />
      <path
        className="cls-1"
        d="M30.67,6.63s-.03,0-.04,0c.01-.03.02-.03.04,0Z"
      />
      <path
        className="cls-1"
        d="M30.19,9.27c-.06.07-.03-.01-.03-.02,0,0,.02.01.03.02Z"
      />
      <path className="cls-1" d="M31.77,7.16h-.01c.03-.07.05-.05.01,0Z" />
      <path
        className="cls-1"
        d="M27.96,22.85s-.07.03-.08.04c0,0,0,.04-.01.05-.02,0-.05-.02-.05-.02,0,0-.05.15-.1.16-.02,0-.06-.05-.14-.03-.03,0-.02.07-.08.08-.03,0-.05,0-.07,0-.02,0-.03.04-.05.04-.03.01-.06-.02-.1,0s-.05.05-.08.06-.06,0-.08,0c0,0,0,.03-.02.04-.04.03-.07.02-.1.04-.01,0,0,.04-.03.06-.07.08-.19.08-.27.04-.03-.02-.06-.07-.09-.07-.06-.01,0,.09,0,.1,0,.01-.23.1-.26.11-.03.01-.05.04-.07.05-.07.02-.18.03-.24,0-.14-.07-.19-.21-.2-.36-.01-.18.13-.32.27-.4.04-.02.13-.05.13-.05.02-.02-.01-.07,0-.09,0-.02.04-.03.05-.05.01-.02,0-.05.02-.06.03-.01.07,0,.09,0,.02,0,0-.06.05-.08s.1.05.14,0c.01-.02-.01-.17,0-.18,0,0,.06.02.08-.02.03-.06.02-.13.04-.18,0-.03.07-.12.07-.13,0-.02-.05-.09-.02-.15.03-.06.19-.1.23-.12.03-.02.02-.07.03-.07.02,0,.04.01.06.01.03,0,.05-.03.08-.04.06-.01.11.04.16.06.1.05.17.09.27.15.08.05.19,0,.27.03.04.01.05.06.06.06.02,0,.24-.07.29-.08.15-.03.27,0,.4.08s.26.27.17.42c-.02.04-.06.04-.07.06-.02.03,0,.06,0,.07,0,0-.04.01-.06.03-.04.04-.02.1-.03.1,0,0-.17.07-.2.09-.01-.02-.03,0-.05,0-.03,0-.06,0-.09.01-.01,0-.02,0-.03,0-.03-.01-.04.02-.07-.06-.02-.06.01-.14-.08-.06-.02.01-.03.13-.04.16-.03,0-.05.02-.07.04-.02.01-.04,0-.02.05Z"
      />
      <path
        className="cls-1"
        d="M26.26,19.48s.04.11.09.14c.01.06.03.11.06.16,0,.06.02.14.04.21.01.04.06.11.06.14,0,.02-.06.02-.07.06,0,.02,0,.17.02.18.05.03.12-.19.15-.06-.01.03,0,.15,0,.18v.03s0,.06,0,.08c-.03,0-.03.01-.02.04-.01.02-.03.08-.02.11.02.03.06,0,.07,0,.03.02-.02.04-.03.06-.01.03,0,.09-.03.13,0,0-.02,0-.03,0-.05.02-.02.08-.06.11-.01.01-.08.06-.08.06,0,0-.05-.05-.05-.06,0-.03.1-.14.07-.19-.11-.05-.1.01-.15.02,0,0-.02-.03-.02-.03-.07,0-.04.09-.06.1,0,0-.11.02-.12.01-.01,0-.14-.12-.15-.15-.1.06-.18.06-.29.03-.29-.07-.5-.47-.56-.74-.04-.18-.06-.5-.02-.68s.23-.38.43-.38c.13,0,.41.14.51.22.04.03.08.1.1.12.04.02.09-.02.16.07Z"
      />
      <path
        className="cls-1"
        d="M26.43,19.74c-.03-.08,0-.14-.01-.21-.03-.15-.11-.21-.08-.38.02-.11.2-.41.29-.48.1-.08.22-.09.34-.05.13.05.16.15.24.24.11.12.19.14.31.3.02.03.08.05.09.09.01.02.06.25.06.29,0,.05-.02.19-.04.24-.02.04-.1.06-.11.07,0,.01,0,.18-.03.25-.02.04-.06.06-.06.11,0,.08.05.12-.03.2-.07.06-.11.02-.12-.06-.03,0,0,.05-.03.07-.02.02-.07,0-.08.01,0,0,.03.08-.02.09-.08.02-.08-.06-.12-.06s-.08.05-.13.05c-.04,0-.07-.04-.1-.04-.04,0-.08.05-.12.05-.03-.05,0-.09,0-.14.04-.04.02-.05,0-.08-.04-.05-.05-.03-.06-.03-.06-.04-.05-.1-.07-.15-.06-.12-.09-.23-.13-.36Z"
      />
      <path
        className="cls-1"
        d="M26.19,21.44c-.09.12-.1.27-.17.38-.03.05-.08.06-.1.09-.05.08-.03.21-.04.28,0,0-.03.11-.03.12,0,.01-.24.18-.26.18-.07.03-.1-.04-.12-.04-.02,0-.04.03-.07.03-.02,0-.03-.03-.05-.03-.14-.04-.22-.07-.35-.14-.21-.1-.14-.36-.14-.54,0-.13-.04-.19,0-.34.05-.17.28-.4.45-.44.05-.01.18-.03.23-.03.07,0,.25-.02.31.01.04.03.04.08.14.13.02,0,.05,0,.05,0,.02.02,0,.1.02.11,0,0,.08,0,.08,0,.02.01,0,.06,0,.06-.01,0-.07-.03-.07,0,0,.03.05.04.07.04,0,.01,0,.02,0,.03,0,.04.02.07.03.1Z"
      />
      <path
        className="cls-1"
        d="M28.48,19.99s.12.01.15.03c.05.03.08.14.12.19.03.04.11.08.12.12.01.03,0,.06.01.09.01.02.06.04.07.07,0,0-.03.01-.03.03,0,.03.06.13.07.19.03.15-.02.28-.09.41-.03.05-.11.16-.16.19-.07.05-.31.15-.39.14-.06,0-.07-.05-.11-.07-.04-.02-.15,0-.17-.03-.02-.03-.02-.07-.04-.09-.01-.02-.05-.02-.08-.04-.03-.03-.13-.17-.16-.21-.07-.1-.1-.27.05-.32,0-.04-.03-.02-.04-.03-.03-.02-.03-.15-.02-.19.01-.02.04-.04.05-.06.04-.17.07-.13.16-.24.01-.02.02-.06.03-.08.07-.12.12-.2.29-.18.08.01.11.06.16.09Z"
      />
      <path
        className="cls-1"
        d="M26.52,21.12c-.01.06.05.14-.03.17l-.02-.06s0,.08,0,.13c0,.08-.07.14-.14.17-.03-.04.02-.09.01-.11,0-.04-.09-.1,0-.11l.03.04c-.02-.06.07-.26.14-.23Z"
      />
      <path
        className="cls-1"
        d="M27.71,19.97s-.06.14-.08.15c-.03.02-.03-.02-.03-.03-.02-.04,0-.07-.06-.04,0-.08.12-.09.14-.12l.03.04Z"
      />
      <path
        className="cls-1"
        d="M28.05,22.76s.02-.15.04-.16c.09-.08.06,0,.08.06-.06,0-.03.05-.07.05-.01,0,0-.04-.03-.02l.04.07s-.04,0-.05,0Z"
      />
      <path
        className="cls-1"
        d="M26.26,19.48l.03-.06s0,.05.02.07c0,0,.12.04.02.04.02.03,0,.08.01.09-.05-.03-.05-.09-.09-.14Z"
      />
      <path
        className="cls-1"
        d="M27.69,19.93s-.02-.02,0-.03c.02-.01.07-.01.1-.03.03.01-.02.14-.05.06,0,0,0,.02-.01.04l-.03-.04Z"
      />
      <path
        className="cls-1"
        d="M26.21,21.97s-.06-.1-.05-.12c.15-.01.03.04.05.12Z"
      />
      <path className="cls-1" d="M26.29,21.62v.09c-.09.02-.1-.08,0-.09Z" />
      <path
        className="cls-1"
        d="M26.58,20.94s.04.02.05.02,0-.02,0-.02c.01-.03.05,0,.05,0,0,.01-.14.13-.13.01,0,0,.02,0,.03,0Z"
      />
      <path
        className="cls-1"
        d="M26.16,21.34s.06.06.03.1c0-.04-.02-.07-.03-.1Z"
      />
      <path
        className="cls-1"
        d="M27.78,19.99s-.03.08-.06.08c0-.02.02-.1.06-.08Z"
      />
      <path
        className="cls-1"
        d="M26.14,21.28s0,.02,0,.03c-.03,0-.06,0-.07-.04,0-.03.05,0,.07,0Z"
      />
      <path
        className="cls-1"
        d="M26.71,20.36s-.03-.06,0-.08c.02.03.05.04,0,.08Z"
      />
      <path
        className="cls-1"
        d="M27.98,22.79c.02.06,0,.04-.02.05-.02-.06,0-.04.02-.05Z"
      />
      <path
        className="cls-1"
        d="M28.41,22.7s-.04.06-.05,0c.02,0,.04-.02.05,0Z"
      />
      <path
        className="cls-1"
        d="M26.61,20.48s.03.01.02.03c0,0-.03,0-.03,0v-.03Z"
      />
      <path
        className="cls-1"
        d="M26.61,20.59c0,.06-.01.02-.02.04-.01-.03,0-.04.02-.04Z"
      />
      <path
        className="cls-1"
        d="M28.26,22.71c0,.09-.03.01-.03,0,.01,0,.02,0,.03,0Z"
      />
      <path className="cls-1" d="M27.74,20.13h-.01c-.03-.06,0-.06.01,0Z" />
      <path
        className="cls-1"
        d="M38.67,18.06s-.06.05-.06.07c0,.01,0,.04,0,.05-.01.01-.05,0-.06,0,0,0,0,.15-.05.18-.02.01-.07-.03-.14.02-.03.02,0,.07-.05.1-.02.02-.05,0-.06.02-.02.01-.02.04-.03.06-.02.02-.06,0-.09.02s-.04.06-.06.08-.06.02-.07.03c0,0,0,.03,0,.05-.02.04-.06.05-.09.07-.01.01,0,.04,0,.07-.04.09-.15.14-.25.12-.04,0-.08-.05-.1-.04-.06,0,.03.08.03.09,0,.01-.18.16-.21.19-.02.02-.03.05-.05.07-.06.05-.16.09-.23.08-.16-.02-.25-.14-.31-.28-.07-.16.03-.34.13-.47.03-.03.1-.08.11-.09,0-.03-.03-.06-.03-.08,0-.02.03-.04.04-.06,0-.02-.01-.05,0-.06.02-.02.07-.02.08-.04.01-.01-.02-.06.02-.09s.11.01.13-.05c0-.02-.07-.16-.06-.17,0-.01.06,0,.07-.05,0-.06-.02-.13-.02-.18,0-.03.03-.14.03-.15,0-.02-.08-.06-.07-.13,0-.06.15-.15.18-.19.02-.03,0-.07,0-.08.02-.01.04,0,.06,0,.02,0,.04-.04.07-.06.05-.03.12,0,.17,0,.12.01.19.03.31.06.1.02.18-.06.26-.06.04,0,.07.04.08.04.02,0,.2-.14.25-.17.14-.07.25-.08.4-.05s.33.18.29.35c-.01.04-.04.06-.05.08,0,.03.03.06.02.07,0,0-.04.03-.05.05-.02.05,0,.1,0,.11,0,.01-.13.12-.16.15-.02-.01-.03,0-.05.01-.03.01-.06.02-.09.04,0,0-.02.01-.03.02-.03,0-.04.03-.08-.04-.04-.05-.03-.14-.1-.04-.01.02,0,.14.02.17-.03.02-.04.03-.06.06-.02.02-.04,0,0,.06Z"
      />
      <path
        className="cls-1"
        d="M35.99,15.41s.07.09.13.1c.03.05.06.1.11.13.01.06.07.13.11.18.03.04.09.09.1.12,0,.02-.05.04-.05.07,0,.02.06.16.08.16.06.01.05-.21.12-.1,0,.03.04.14.06.17v.03s.03.06.04.07c-.03.01-.03.02,0,.04,0,.03,0,.09.02.11.02.02.06-.01.07-.01.04,0,0,.05,0,.07,0,.04.03.09.02.13,0,0-.02.01-.03.02-.04.03,0,.08-.02.13,0,.01-.06.08-.06.08,0,0-.06-.03-.06-.04-.01-.03.05-.16,0-.2-.12-.02-.09.04-.13.07,0,0-.02-.02-.03-.02-.06.03,0,.1-.02.11,0,0-.1.05-.11.05-.01,0-.17-.07-.19-.09-.08.09-.15.11-.26.12-.3.02-.62-.29-.76-.53-.09-.16-.22-.46-.23-.64s.09-.43.29-.5c.12-.04.43,0,.55.05.04.02.11.07.13.08.04.01.08-.05.17.02Z"
      />
      <path
        className="cls-1"
        d="M36.24,15.6c-.05-.07-.04-.13-.08-.2-.07-.14-.17-.17-.19-.34-.01-.12.06-.46.12-.55.07-.1.17-.16.3-.15.14,0,.2.1.31.15.14.08.22.07.39.18.03.02.09.02.11.05.02.02.13.22.15.25.02.05.04.19.03.24,0,.05-.07.09-.08.1,0,.01.06.17.05.25,0,.04-.04.07-.02.12.02.07.09.1.04.2-.04.08-.09.05-.13-.02-.02.02,0,.05,0,.07-.01.02-.07.02-.07.04,0,.01.05.06.01.09-.07.04-.09-.03-.13-.02s-.06.07-.1.09c-.04.02-.07-.01-.1,0-.04.01-.06.07-.1.08-.04-.04-.03-.09-.05-.13.03-.05,0-.05-.03-.07-.05-.04-.05,0-.06-.01-.07-.02-.08-.08-.12-.12-.09-.1-.16-.19-.24-.3Z"
      />
      <path
        className="cls-1"
        d="M36.54,17.29c-.05.15,0,.29-.04.41-.01.05-.06.08-.07.12-.02.09.04.21.05.28,0,0,0,.12,0,.12,0,.02-.17.24-.19.26-.06.05-.1,0-.13,0-.02,0-.03.04-.05.05-.02,0-.04-.02-.06-.02-.15,0-.23,0-.37-.02-.23-.03-.24-.3-.31-.47-.05-.12-.1-.17-.11-.32,0-.17.14-.47.29-.56.04-.02.16-.08.21-.1.06-.03.23-.1.3-.08.05.02.07.06.18.08.02,0,.04-.02.05-.01.03.01.04.09.05.1,0,0,.07-.03.07-.03.02,0,.02.05.02.06-.01,0-.08,0-.06.02.02.03.06.02.08,0,0,0,.01.02.02.03.02.03.04.06.06.09Z"
      />
      <path
        className="cls-1"
        d="M38.26,15.19s.12-.02.15-.02c.06.02.12.1.18.14.04.03.13.04.15.07.02.02.02.05.04.08.02.02.07.02.08.04,0,0-.02.02-.02.03.01.03.1.1.13.16.07.13.07.28.04.42,0,.06-.06.19-.09.23-.05.07-.24.24-.32.25-.06.01-.08-.02-.13-.03-.05,0-.14.04-.17.02-.03-.02-.04-.06-.06-.08-.01-.01-.06,0-.09-.01-.04-.02-.18-.12-.22-.15-.1-.08-.18-.23-.06-.32-.01-.04-.03,0-.04-.01-.03-.01-.08-.13-.07-.17,0-.03.03-.05.02-.07-.01-.17.03-.15.08-.28,0-.02,0-.06,0-.09.03-.14.05-.23.22-.26.08-.01.12.03.18.03Z"
      />
      <path
        className="cls-1"
        d="M36.76,16.88c0,.06.09.12.02.17l-.04-.05s.03.08.04.12c.02.08-.02.15-.08.2-.05-.03-.01-.09-.02-.11-.02-.04-.11-.06-.03-.1l.04.03c-.04-.05-.01-.27.06-.27Z"
      />
      <path
        className="cls-1"
        d="M37.52,15.42s-.02.15-.03.17c-.02.03-.03,0-.04-.02-.03-.03-.02-.06-.07-.02-.03-.08.09-.12.1-.16l.04.03Z"
      />
      <path
        className="cls-1"
        d="M38.73,17.95s-.03-.15-.02-.17c.06-.1.06-.02.1.04-.05.02,0,.06-.05.07-.01,0-.02-.03-.04-.01l.06.06s-.04.01-.05.01Z"
      />
      <path
        className="cls-1"
        d="M35.99,15.41v-.06s.04.04.05.06c0,0,.13,0,.03.03.03.02.03.07.04.09-.06-.01-.08-.07-.13-.1Z"
      />
      <path
        className="cls-1"
        d="M37.49,15.39s-.02-.02,0-.03c.02-.02.06-.03.08-.06.03,0,.03.14-.03.08,0,0,0,.03,0,.04l-.04-.03Z"
      />
      <path
        className="cls-1"
        d="M36.73,17.79s-.09-.08-.08-.09c.14-.06.04.03.08.09Z"
      />
      <path className="cls-1" d="M36.7,17.43l.04.09c-.09.05-.13-.04-.04-.09Z" />
      <path
        className="cls-1"
        d="M36.76,16.69s.04,0,.05,0,0-.02,0-.02c0-.03.04-.02.05-.02,0,.01-.09.16-.12.05,0,0,.02-.02.03-.02Z"
      />
      <path
        className="cls-1"
        d="M36.48,17.2s.08.04.06.09c-.02-.03-.04-.06-.06-.09Z"
      />
      <path
        className="cls-1"
        d="M37.59,15.41s0,.09-.03.1c0-.02-.01-.1.03-.1Z"
      />
      <path
        className="cls-1"
        d="M36.45,17.15s.01.02.02.03c-.03.01-.06.02-.08,0-.02-.02.05-.02.06-.02Z"
      />
      <path
        className="cls-1"
        d="M36.69,16.1s-.05-.05-.03-.07c.03.02.06.02.03.07Z"
      />
      <path
        className="cls-1"
        d="M38.67,18.01s.02.03,0,.06c-.04-.05-.02-.04,0-.06Z"
      />
      <path
        className="cls-1"
        d="M39.05,17.79s-.02.07-.05.01c.01,0,.03-.03.05-.01Z"
      />
      <path
        className="cls-1"
        d="M36.64,16.25s.03,0,.03.02c0,0-.02.01-.03.02v-.03Z"
      />
      <path
        className="cls-1"
        d="M36.68,16.35c.02.06,0,.03,0,.04-.02-.02-.02-.03,0-.04Z"
      />
      <path
        className="cls-1"
        d="M38.92,17.84c.04.08-.02.02-.03.02,0,0,.02-.01.03-.02Z"
      />
      <path className="cls-1" d="M37.6,15.55h-.01s-.02-.06.01,0Z" />
      <path
        className="cls-1"
        d="M43.54,9.4s-.06-.05-.08-.05c-.01,0-.04.02-.05,0-.02-.01,0-.05,0-.06,0,0-.15.02-.19-.02-.02-.02.02-.08-.04-.14-.02-.02-.07.02-.11-.03-.02-.02-.01-.05-.02-.06-.01-.02-.05,0-.06-.02-.02-.02-.01-.06-.04-.09s-.07-.03-.09-.05-.03-.05-.04-.07c0,0-.03.01-.05,0-.04-.02-.06-.06-.08-.07-.01,0-.04.01-.07,0-.1-.02-.16-.13-.16-.23,0-.04.03-.09.03-.11-.02-.06-.08.05-.08.05-.01,0-.19-.16-.22-.18-.02-.02-.06-.02-.08-.04-.05-.05-.11-.14-.11-.22,0-.16.1-.27.23-.35.15-.09.34-.02.48.06.04.02.1.09.11.09.03,0,.05-.04.08-.04.02,0,.04.02.07.03.02,0,.05-.02.06,0,.02.02.03.06.05.08.01.01.06-.03.09,0s0,.11.07.12c.02,0,.14-.09.15-.09.01,0,.01.06.06.06.06,0,.13-.04.18-.05.03,0,.14.01.15,0,.02,0,.05-.08.12-.09.06,0,.17.12.21.15.03.02.07-.01.08,0,.01.02,0,.04.01.06.01.02.05.03.07.06.04.05.02.11.02.17,0,.12,0,.2-.01.31,0,.1.09.17.1.25,0,.04-.03.07-.02.08,0,.02.17.18.2.22.09.12.12.24.11.39s-.13.36-.3.34c-.04,0-.07-.03-.09-.04-.03,0-.05.03-.06.03,0,0-.03-.03-.06-.04-.05-.01-.1.02-.11.02-.01,0-.14-.11-.17-.13.01-.02-.01-.03-.02-.04-.02-.03-.03-.05-.05-.08,0,0-.01-.01-.02-.02,0-.03-.03-.03.03-.09.05-.04.13-.05.02-.1-.02,0-.13.03-.16.04-.02-.03-.04-.03-.06-.05-.02-.01-.02-.04-.06,0Z"
      />
      <path
        className="cls-1"
        d="M45.78,6.36c-.03.05-.08.08-.08.14-.04.03-.09.08-.12.13-.06.02-.12.08-.17.13-.03.03-.07.1-.1.12-.02,0-.05-.04-.08-.04-.02,0-.15.09-.15.1,0,.06.22.02.12.1-.03,0-.14.06-.16.08h-.03s-.05.04-.07.05c-.02-.02-.03-.02-.04,0-.03,0-.09.01-.1.03-.02.03.02.06.02.06,0,.04-.05,0-.07,0-.04,0-.08.04-.13.04,0,0-.01-.02-.02-.02-.04-.03-.08.01-.13,0-.01,0-.09-.05-.09-.05,0,0,.02-.07.03-.07.03-.02.17.03.2-.02,0-.12-.06-.09-.09-.12,0,0,.02-.03.01-.03-.04-.06-.1,0-.11,0,0,0-.06-.09-.07-.1,0-.01.05-.18.06-.2-.1-.07-.13-.13-.16-.24-.07-.29.19-.66.41-.83.14-.11.42-.29.6-.32s.44.03.53.21c.06.12.06.42.03.55,0,.04-.06.12-.06.14,0,.04.06.07,0,.17Z"
      />
      <path
        className="cls-1"
        d="M45.62,6.63c.06-.06.12-.06.19-.11.13-.09.14-.19.31-.24.11-.03.46-.01.56.04.11.06.18.15.2.28.02.14-.07.21-.11.33-.06.15-.04.23-.12.41-.02.04-.01.09-.03.12-.02.02-.2.16-.23.19-.04.03-.18.07-.23.07-.05,0-.1-.06-.11-.06-.01,0-.16.08-.24.09-.04,0-.08-.03-.12,0-.07.03-.09.11-.19.07-.09-.03-.06-.09,0-.13-.02-.02-.04.01-.07,0-.02,0-.03-.06-.05-.06-.01,0-.06.06-.08.03-.05-.06.02-.1,0-.13s-.08-.05-.1-.09c-.02-.04,0-.08-.01-.1-.02-.03-.08-.05-.1-.09.03-.05.08-.05.12-.07.05.02.05,0,.07-.04.03-.06,0-.06,0-.07,0-.07.06-.09.1-.13.08-.1.17-.19.26-.28Z"
      />
      <path
        className="cls-1"
        d="M43.99,7.18c-.15-.03-.29.04-.41.02-.06,0-.09-.05-.13-.05-.09,0-.2.07-.27.1,0,0-.12.02-.12.02-.02,0-.26-.13-.28-.15-.06-.05,0-.1-.02-.13,0-.02-.05-.02-.06-.05,0-.02.01-.04,0-.06-.02-.14-.04-.23-.04-.37,0-.23.26-.28.42-.37.12-.07.15-.12.3-.15.17-.03.49.07.6.2.03.04.1.15.13.19.04.06.14.22.13.28,0,.05-.05.08-.05.19,0,.02.02.04.02.05,0,.03-.09.05-.09.06,0,0,.04.06.04.07,0,.02-.05.03-.06.03,0-.01,0-.08-.03-.06-.02.02-.02.06,0,.08,0,0-.02.01-.02.02-.03.02-.05.05-.08.07Z"
      />
      <path
        className="cls-1"
        d="M46.33,8.57s.04.11.04.15c0,.06-.09.14-.11.19-.02.04-.02.13-.05.16-.02.02-.05.02-.07.05-.01.02,0,.07-.03.09,0,0-.03-.02-.04-.01-.03.02-.09.11-.14.15-.12.09-.26.11-.41.1-.06,0-.19-.03-.24-.06-.07-.04-.27-.21-.3-.28-.02-.05.01-.08,0-.13,0-.05-.06-.13-.05-.17.01-.03.05-.05.07-.07,0-.02,0-.06,0-.09,0-.04.09-.2.11-.24.06-.11.2-.21.31-.1.04-.02,0-.03,0-.04,0-.03.12-.1.16-.1.03,0,.05.02.08.01.17-.04.15,0,.29.03.02,0,.06-.01.09,0,.14,0,.23.01.29.18.02.07,0,.13,0,.18Z"
      />
      <path
        className="cls-1"
        d="M44.43,7.33c-.06.02-.1.11-.17.05l.05-.04s-.08.04-.12.06c-.07.04-.15,0-.21-.05.02-.05.08-.03.1-.04.04-.02.05-.12.1-.04l-.02.04s.26-.05.27.02Z"
      />
      <path
        className="cls-1"
        d="M45.99,7.87s-.15,0-.17,0c-.03-.01,0-.03.01-.04.03-.03.06-.03,0-.07.07-.04.13.07.17.07l-.02.04Z"
      />
      <path
        className="cls-1"
        d="M43.66,9.44s.14-.05.16-.04c.11.05.02.06-.02.1-.02-.05-.06,0-.08-.04,0-.01.03-.02,0-.04l-.05.06s-.02-.04-.02-.04Z"
      />
      <path
        className="cls-1"
        d="M45.78,6.36h.07s-.04.03-.05.05c0,0,.02.13-.02.04-.01.03-.07.04-.08.05,0-.06.06-.09.08-.14Z"
      />
      <path
        className="cls-1"
        d="M46.02,7.83s.01-.02.03-.01c.02.02.04.05.07.07,0,.03-.13.05-.08-.02,0,0-.02,0-.04,0l.02-.04Z"
      />
      <path
        className="cls-1"
        d="M43.53,7.44s.07-.1.08-.1c.08.13-.02.04-.08.1Z"
      />
      <path className="cls-1" d="M43.88,7.35l-.08.05c-.06-.08.02-.13.08-.05Z" />
      <path
        className="cls-1"
        d="M44.62,7.3s0,.04,0,.05.02,0,.02,0c.03,0,.03.04.02.04-.01,0-.18-.07-.07-.11,0,0,.02.02.02.02Z"
      />
      <path
        className="cls-1"
        d="M44.07,7.11s-.03.08-.08.07c.03-.02.05-.05.08-.07Z"
      />
      <path
        className="cls-1"
        d="M46.01,7.94s-.09,0-.1-.01c.02,0,.1-.03.1.01Z"
      />
      <path
        className="cls-1"
        d="M44.12,7.06s-.02.01-.02.02c-.02-.02-.03-.06,0-.08.02-.02.02.05.03.06Z"
      />
      <path
        className="cls-1"
        d="M45.19,7.15s.04-.05.07-.04c-.02.03-.01.06-.07.04Z"
      />
      <path
        className="cls-1"
        d="M43.6,9.39s-.03.02-.06,0c.04-.05.03-.02.06,0Z"
      />
      <path
        className="cls-1"
        d="M43.87,9.73s-.07,0-.02-.04c0,.01.03.02.02.04Z"
      />
      <path
        className="cls-1"
        d="M45.04,7.12s0,.03-.01.03c0,0-.02-.02-.02-.02h.03Z"
      />
      <path
        className="cls-1"
        d="M44.94,7.17c-.05.03-.03,0-.04,0,.02-.02.03-.02.04,0Z"
      />
      <path
        className="cls-1"
        d="M43.8,9.61c-.08.05-.02-.02-.02-.02,0,0,.02.01.02.02Z"
      />
      <path className="cls-1" d="M45.87,7.97h-.01c.04-.06.06-.04.01,0Z" />
      <path
        className="cls-1"
        d="M5.17,29.53s-.07.03-.08.05c0,.01,0,.04-.01.05-.02.01-.05-.02-.05-.02,0,0-.05.15-.1.16-.02,0-.06-.05-.14-.02-.03.01-.01.07-.07.08-.03,0-.05,0-.07,0-.02,0-.03.04-.05.05-.03.01-.06-.01-.1,0s-.05.05-.08.06-.06,0-.08,0c0,0,0,.03-.02.04-.03.03-.07.03-.1.04-.01,0,0,.04-.02.06-.06.08-.18.09-.27.05-.03-.02-.06-.07-.09-.07-.06,0,0,.09,0,.1,0,.01-.22.1-.26.12-.03.01-.04.04-.07.05-.07.03-.18.04-.24,0-.14-.06-.2-.21-.22-.36-.02-.17.12-.32.26-.41.04-.02.12-.05.13-.06.02-.02-.01-.06,0-.09,0-.02.04-.03.05-.05.01-.02,0-.05.02-.06.03-.01.07,0,.09,0,.01,0,0-.06.04-.08s.1.04.14,0c.01-.02-.02-.17-.01-.18,0,0,.06.01.08-.02.03-.06.02-.13.03-.18,0-.03.07-.12.07-.13,0-.02-.05-.08-.03-.14.02-.06.18-.1.23-.13.03-.02.02-.07.03-.07.02,0,.04.01.06.01.03,0,.05-.03.08-.04.06-.01.11.03.16.05.11.05.18.08.28.15.08.05.19,0,.27.02.04.01.05.05.06.06.02,0,.23-.08.29-.09.15-.03.27,0,.4.07s.27.27.18.42c-.02.04-.06.05-.07.06-.02.03,0,.06,0,.07,0,0-.04.02-.06.04-.03.04-.02.1-.03.1,0,0-.16.08-.19.1-.01-.02-.03,0-.05,0-.03,0-.06,0-.09.01-.01,0-.02,0-.03,0-.03-.01-.04.02-.07-.06-.02-.06,0-.14-.08-.06-.02.01-.03.13-.03.16-.03,0-.04.02-.07.04-.02.02-.04,0-.02.05Z"
      />
      <path
        className="cls-1"
        d="M3.36,26.22s.04.1.09.13c.01.06.03.11.07.16,0,.06.03.14.05.21.01.04.06.11.06.14,0,.02-.06.03-.07.06,0,.02.02.17.03.18.05.03.11-.19.14-.06,0,.03,0,.15,0,.18v.03s0,.06,0,.08c-.03,0-.03.01-.02.04-.01.02-.03.09-.01.11.02.03.06,0,.07,0,.03.02-.02.04-.03.06-.01.03,0,.09-.02.13,0,0-.02,0-.03,0-.05.02-.02.08-.06.12-.01.01-.08.06-.08.06,0,0-.05-.05-.05-.05,0-.03.1-.14.07-.19-.11-.05-.1.01-.14.03,0,0-.02-.03-.02-.03-.07,0-.03.09-.05.1,0,0-.11.02-.12.02-.01,0-.14-.12-.16-.14-.1.06-.17.07-.29.04-.29-.06-.51-.45-.58-.72-.04-.18-.08-.5-.04-.68s.22-.39.42-.39c.13,0,.41.13.51.21.04.03.08.1.1.11.04.02.09-.02.16.06Z"
      />
      <path
        className="cls-1"
        d="M3.54,26.47c-.03-.08,0-.14-.02-.21-.03-.15-.12-.21-.09-.38.02-.12.19-.42.27-.49.1-.08.21-.1.33-.06.14.04.16.15.25.24.11.11.19.13.32.29.03.03.08.05.09.08.01.02.07.25.07.28,0,.05-.01.19-.04.24-.02.04-.1.07-.1.08,0,.01,0,.18-.02.25-.01.04-.06.06-.06.11,0,.08.06.12-.02.2-.06.06-.1.02-.12-.06-.03,0,0,.05-.03.07-.02.02-.07,0-.08.02,0,0,.03.08-.01.09-.08.02-.08-.06-.12-.06s-.08.05-.13.06c-.04,0-.07-.03-.1-.03-.04,0-.08.05-.12.05-.03-.05,0-.09-.01-.14.04-.04.01-.05,0-.08-.04-.05-.05-.02-.06-.03-.06-.04-.05-.09-.08-.15-.06-.12-.1-.23-.15-.35Z"
      />
      <path
        className="cls-1"
        d="M3.35,28.18c-.09.13-.09.28-.16.38-.03.05-.08.06-.1.1-.04.08-.02.21-.03.28,0,0-.03.11-.03.12,0,.01-.23.18-.25.19-.07.03-.1-.04-.12-.04-.02,0-.04.03-.07.03-.02,0-.03-.03-.05-.03-.14-.04-.22-.06-.35-.13-.21-.1-.15-.35-.16-.54,0-.13-.05-.19,0-.34.04-.17.27-.41.44-.46.05-.01.18-.03.23-.04.07,0,.25-.03.31,0,.05.03.05.08.15.12.02,0,.05,0,.05,0,.02.02.01.1.02.11,0,0,.08,0,.08,0,.02.01,0,.06,0,.06-.01,0-.08-.03-.07,0,.01.03.05.04.08.03,0,0,0,.02,0,.03.01.03.02.07.03.1Z"
      />
      <path
        className="cls-1"
        d="M5.6,26.66s.12.01.15.03c.05.03.09.14.13.18.03.04.11.07.13.12.01.03,0,.06.02.08.01.02.06.03.07.06,0,0-.03.02-.03.03,0,.03.06.12.08.19.03.15-.02.28-.08.42-.03.05-.11.16-.15.19-.07.05-.3.16-.38.15-.06,0-.07-.05-.12-.06-.04-.01-.15,0-.17-.03-.02-.03-.02-.07-.04-.09-.01-.01-.05-.02-.08-.04-.03-.03-.14-.16-.17-.2-.07-.1-.11-.27.04-.32,0-.04-.03-.02-.04-.02-.03-.02-.04-.15-.02-.19,0-.02.04-.04.04-.06.04-.17.07-.13.15-.24.01-.02.01-.06.03-.08.07-.13.11-.21.28-.19.08,0,.11.06.16.08Z"
      />
      <path
        className="cls-1"
        d="M3.67,27.85c-.01.06.05.14-.03.17l-.02-.06s0,.08,0,.13c0,.08-.07.14-.13.17-.04-.04.01-.09,0-.11,0-.04-.09-.09,0-.11l.03.04c-.02-.06.07-.26.14-.24Z"
      />
      <path
        className="cls-1"
        d="M4.83,26.67s-.06.14-.07.15c-.03.02-.03-.02-.03-.03-.02-.04,0-.07-.06-.04,0-.08.12-.09.14-.13l.03.04Z"
      />
      <path
        className="cls-1"
        d="M5.25,29.44s.02-.15.03-.16c.09-.08.06,0,.08.06-.06,0-.02.05-.07.06-.01,0,0-.04-.03-.02l.04.07s-.04,0-.05,0Z"
      />
      <path
        className="cls-1"
        d="M3.36,26.22l.03-.06s.01.05.02.06c0,0,.12.04.03.03.03.03,0,.08.01.09-.05-.03-.05-.09-.09-.13Z"
      />
      <path
        className="cls-1"
        d="M4.8,26.63s-.02-.02,0-.03c.02-.01.07-.02.09-.03.03.01-.01.14-.05.07,0,0,0,.02-.01.04l-.03-.04Z"
      />
      <path
        className="cls-1"
        d="M3.39,28.71s-.06-.1-.05-.11c.15-.02.03.04.05.11Z"
      />
      <path className="cls-1" d="M3.46,28.36v.09c-.08.02-.1-.07,0-.09Z" />
      <path
        className="cls-1"
        d="M3.73,27.67s.04.02.05.02,0-.02,0-.02c.01-.03.05,0,.05,0,0,.01-.13.13-.13.02,0,0,.02,0,.03,0Z"
      />
      <path
        className="cls-1"
        d="M3.32,28.08s.06.06.03.1c-.01-.03-.02-.07-.03-.1Z"
      />
      <path
        className="cls-1"
        d="M4.9,26.68s-.03.08-.06.08c0-.02.02-.1.06-.08Z"
      />
      <path
        className="cls-1"
        d="M3.3,28.02s0,.02,0,.03c-.03,0-.07,0-.08-.03,0-.03.05,0,.07,0Z"
      />
      <path
        className="cls-1"
        d="M3.83,27.08s-.03-.06,0-.08c.02.03.05.04,0,.08Z"
      />
      <path
        className="cls-1"
        d="M5.18,29.48c.02.06.01.04-.02.05-.03-.06,0-.04.02-.05Z"
      />
      <path
        className="cls-1"
        d="M5.61,29.38s-.04.06-.05,0c.02,0,.04-.02.05,0Z"
      />
      <path
        className="cls-1"
        d="M3.74,27.21s.03.01.02.02c0,0-.03,0-.03,0v-.03Z"
      />
      <path
        className="cls-1"
        d="M3.75,27.32c0,.06-.01.02-.02.04-.01-.03,0-.04.02-.04Z"
      />
      <path
        className="cls-1"
        d="M5.46,29.39c.01.09-.03.01-.03,0,0,0,.02,0,.03,0Z"
      />
      <path className="cls-1" d="M4.86,26.82h-.01c-.03-.05,0-.06.01,0Z" />
      <path
        className="cls-1"
        d="M16.37,30.96s-.05-.05-.07-.06c-.01,0-.04.01-.05,0-.02-.01,0-.05,0-.06,0,0-.15,0-.19-.03-.01-.02.02-.08-.03-.14-.02-.02-.07.01-.1-.04-.02-.02-.01-.05-.02-.06-.01-.02-.04-.01-.06-.03-.02-.02,0-.06-.03-.09s-.06-.03-.08-.05-.02-.05-.03-.07c0,0-.03.01-.05,0-.04-.02-.05-.06-.08-.08-.01,0-.04,0-.07,0-.1-.03-.15-.14-.14-.24,0-.04.04-.08.03-.11-.01-.06-.08.04-.09.04-.01,0-.18-.17-.21-.2-.02-.02-.05-.03-.07-.05-.05-.05-.1-.15-.09-.22,0-.16.12-.26.26-.33.16-.08.34,0,.48.1.03.02.09.1.1.1.03,0,.06-.04.08-.04.02,0,.04.03.06.03.02,0,.05-.01.06,0,.02.02.02.06.04.08.01.01.06-.02.09.01s0,.11.06.13c.02,0,.15-.08.16-.08.01,0,0,.06.05.07.06,0,.13-.03.18-.04.03,0,.14.02.15.02.02,0,.06-.08.12-.08.06,0,.16.13.2.16.03.02.07,0,.08,0,.01.02,0,.04,0,.06.01.02.05.03.07.06.03.05.01.12,0,.17,0,.12-.02.19-.04.31-.02.1.07.17.08.26,0,.04-.03.07-.03.08,0,.02.16.19.18.24.08.13.1.25.08.4s-.15.35-.32.32c-.04,0-.06-.04-.08-.04-.03,0-.05.03-.06.03,0,0-.03-.03-.06-.04-.05-.02-.1.01-.11.01-.01,0-.13-.12-.16-.15.01-.02,0-.03-.02-.05-.02-.03-.03-.06-.05-.08,0,0-.01-.02-.02-.02,0-.03-.03-.03.03-.09.05-.04.14-.04.03-.1-.02,0-.13.02-.16.03-.02-.03-.03-.03-.06-.05-.02-.01-.01-.04-.06,0Z"
      />
      <path
        className="cls-1"
        d="M18.81,28.09c-.03.05-.08.08-.09.13-.05.03-.09.07-.12.12-.06.02-.12.08-.17.12-.03.03-.08.1-.11.11-.02,0-.04-.04-.08-.04-.02,0-.16.08-.16.09,0,.06.22.04.11.11-.03,0-.14.05-.16.07h-.03s-.06.04-.07.04c-.01-.03-.02-.03-.04,0-.03,0-.09,0-.11.03-.02.02.02.06.02.06,0,.04-.05,0-.07,0-.04,0-.09.03-.13.03,0,0-.01-.02-.02-.02-.03-.04-.08,0-.13-.01-.01,0-.08-.05-.08-.06,0,0,.03-.06.03-.07.03-.02.16.04.2,0,0-.12-.05-.09-.08-.12,0,0,.02-.03.02-.03-.03-.06-.1,0-.11-.01,0,0-.06-.09-.06-.11,0-.01.06-.18.08-.2-.09-.07-.12-.14-.14-.25-.05-.29.24-.64.47-.8.15-.1.44-.25.62-.28s.44.06.52.25c.05.12.03.43,0,.55-.01.04-.06.11-.07.14,0,.04.05.07,0,.17Z"
      />
      <path
        className="cls-1"
        d="M18.64,28.35c.06-.06.13-.05.19-.09.13-.08.15-.18.32-.22.11-.02.46.02.56.08.11.06.17.16.18.29,0,.14-.08.21-.13.32-.07.15-.05.23-.15.4-.02.03-.02.09-.04.12-.02.02-.21.15-.24.17-.05.03-.18.06-.24.05-.05,0-.1-.07-.11-.07-.01,0-.17.07-.24.07-.04,0-.07-.03-.12-.01-.07.03-.09.1-.19.05-.08-.04-.06-.09,0-.13-.02-.02-.05.01-.07,0-.02-.01-.03-.06-.04-.07-.01,0-.06.06-.09.02-.05-.07.03-.1.01-.13s-.07-.06-.1-.1c-.02-.04,0-.07,0-.1-.02-.03-.07-.05-.09-.09.03-.04.09-.04.13-.06.05.02.05,0,.07-.04.03-.06,0-.05,0-.07.01-.07.07-.08.11-.13.09-.1.18-.18.28-.26Z"
      />
      <path
        className="cls-1"
        d="M16.97,28.78c-.15-.04-.29.02-.41,0-.05-.01-.09-.05-.13-.06-.09-.01-.2.05-.27.08,0,0-.12.02-.12.01-.02,0-.25-.15-.27-.17-.05-.06,0-.11-.01-.13,0-.02-.04-.02-.06-.05,0-.02.01-.04.01-.06-.01-.14-.02-.23,0-.37.02-.23.28-.26.45-.34.12-.06.16-.11.31-.13.17-.02.48.11.58.24.03.04.09.16.12.2.03.06.12.23.11.29-.01.05-.06.07-.06.18,0,.02.02.04.02.05,0,.03-.09.05-.09.06,0,0,.04.07.04.07,0,.02-.05.02-.06.03,0-.01,0-.08-.02-.06-.02.02-.02.06,0,.08,0,0-.02.01-.02.02-.03.02-.06.05-.09.07Z"
      />
      <path
        className="cls-1"
        d="M19.2,30.34s.03.12.03.15c-.01.06-.09.13-.13.19-.02.04-.03.13-.06.16-.02.02-.05.02-.07.05-.02.02-.01.07-.04.09,0,0-.02-.02-.03-.01-.03.01-.09.1-.15.14-.13.08-.27.09-.42.07-.06,0-.19-.04-.24-.07-.07-.04-.26-.22-.28-.3-.02-.06.02-.08.02-.13,0-.05-.05-.14-.04-.17.02-.03.05-.04.07-.07.01-.02,0-.06,0-.09.01-.04.1-.19.13-.23.07-.1.22-.2.31-.08.04-.02,0-.03,0-.04,0-.03.13-.09.16-.09.03,0,.05.02.08.02.17-.03.15.02.28.06.02,0,.06,0,.09,0,.14.02.23.03.28.2.02.07-.02.13-.02.18Z"
      />
      <path
        className="cls-1"
        d="M17.4,28.96c-.06.01-.11.1-.17.04l.05-.04s-.08.03-.12.05c-.08.03-.15-.01-.21-.06.03-.05.09-.02.11-.03.04-.02.06-.12.1-.04l-.03.04s.27-.03.27.04Z"
      />
      <path
        className="cls-1"
        d="M18.92,29.62s-.15,0-.17-.01c-.03-.02,0-.03.02-.04.03-.03.06-.02.01-.07.07-.03.13.08.17.09l-.03.04Z"
      />
      <path
        className="cls-1"
        d="M16.49,31.01s.14-.04.16-.03c.11.05.02.06-.03.1-.02-.05-.06,0-.08-.05,0-.01.03-.02.01-.04l-.05.06s-.01-.04-.02-.05Z"
      />
      <path
        className="cls-1"
        d="M18.81,28.09h.07s-.04.03-.05.05c0,0,.01.13-.02.04-.02.03-.07.04-.08.05.01-.06.06-.08.09-.13Z"
      />
      <path
        className="cls-1"
        d="M18.95,29.58s.02-.02.03-.01c.02.02.04.06.06.08,0,.03-.14.04-.08-.03,0,0-.02,0-.04,0l.03-.04Z"
      />
      <path
        className="cls-1"
        d="M16.5,29.01s.07-.09.09-.09c.07.14-.02.04-.09.09Z"
      />
      <path
        className="cls-1"
        d="M16.85,28.95l-.08.05c-.06-.08.03-.13.08-.05Z"
      />
      <path
        className="cls-1"
        d="M17.59,28.95s0,.04,0,.05.02,0,.02,0c.03,0,.02.04.02.04-.01,0-.17-.08-.06-.11,0,0,.02.02.02.02Z"
      />
      <path
        className="cls-1"
        d="M17.06,28.71s-.03.08-.09.07c.03-.02.06-.05.09-.07Z"
      />
      <path
        className="cls-1"
        d="M18.93,29.69s-.09,0-.1-.02c.02,0,.1-.02.1.02Z"
      />
      <path
        className="cls-1"
        d="M17.11,28.68s-.02.01-.02.02c-.02-.02-.02-.06,0-.08.02-.02.02.05.02.06Z"
      />
      <path
        className="cls-1"
        d="M18.18,28.84s.04-.05.07-.04c-.02.03-.02.06-.07.04Z"
      />
      <path
        className="cls-1"
        d="M16.42,30.96s-.03.02-.06,0c.04-.05.03-.02.06,0Z"
      />
      <path
        className="cls-1"
        d="M16.67,31.32s-.07-.01-.02-.05c0,.01.03.03.02.05Z"
      />
      <path
        className="cls-1"
        d="M18.02,28.8s0,.03-.01.03c0,0-.01-.02-.02-.02h.03Z"
      />
      <path
        className="cls-1"
        d="M17.92,28.84c-.05.03-.03,0-.04,0,.02-.02.03-.02.04,0Z"
      />
      <path
        className="cls-1"
        d="M16.61,31.19c-.08.04-.02-.02-.02-.02,0,0,.01.02.02.02Z"
      />
      <path className="cls-1" d="M18.79,29.7h0c.05-.06.06-.03,0,0Z" />
      <path
        className="cls-1"
        d="M43.77,27.56s-.07-.03-.08-.03c-.01,0-.03.02-.05.02-.02,0-.02-.05-.02-.05,0,0-.15.05-.19.02-.02-.01,0-.08-.07-.12-.03-.02-.06.03-.11,0-.02-.02-.02-.04-.04-.06-.02-.01-.05,0-.07-.01-.03-.02-.03-.06-.06-.08s-.07-.01-.1-.03-.04-.05-.05-.06c0,0-.02.02-.04.01-.04,0-.07-.04-.1-.05-.01,0-.04.02-.07.02-.1,0-.18-.09-.2-.19,0-.03.01-.09,0-.11-.03-.05-.07.06-.07.06-.01,0-.22-.11-.25-.13-.02-.01-.06-.01-.08-.03-.06-.04-.14-.12-.15-.19-.04-.15.04-.28.15-.39.13-.12.33-.1.48-.04.04.01.12.07.12.07.03,0,.04-.05.07-.06.02,0,.05.01.07.01.02,0,.04-.03.05-.02.03.01.04.06.06.07.01,0,.05-.04.09-.02s.03.11.09.11c.02,0,.12-.12.13-.12.01,0,.03.06.07.05.06-.01.12-.07.16-.09.02-.01.14-.02.15-.02.01,0,.03-.09.1-.11.06-.02.19.08.24.1.04.01.07-.03.08-.02.02.01.01.04.02.05.02.02.06.02.08.04.05.04.04.11.06.16.03.11.04.19.05.31.01.1.12.14.15.22.01.04,0,.08,0,.09,0,.02.2.14.24.17.12.1.17.21.19.36s-.05.38-.22.4c-.04,0-.07-.02-.09-.02-.03,0-.04.04-.05.05,0,0-.04-.02-.07-.03-.05,0-.09.04-.1.04-.01,0-.16-.08-.2-.09,0-.02-.02-.03-.03-.04-.02-.02-.04-.05-.07-.07,0,0-.02-.01-.03-.02,0-.03-.04-.02,0-.09.03-.05.12-.08,0-.1-.02,0-.12.06-.15.07-.03-.02-.04-.02-.07-.03-.02,0-.02-.04-.05.02Z"
      />
      <path
        className="cls-1"
        d="M45.29,24.1c-.01.06-.06.1-.05.15-.04.04-.07.1-.08.15-.05.03-.1.11-.13.16-.02.04-.05.11-.07.14-.02.01-.06-.03-.09-.02-.02,0-.13.12-.12.13.01.06.22-.03.14.08-.03,0-.12.09-.14.11l-.03.02s-.05.04-.06.06c-.02-.02-.03-.02-.04,0-.03,0-.09.03-.09.06,0,.03.04.05.04.06,0,.04-.05.01-.07.02-.03,0-.07.06-.12.06,0,0-.02-.01-.03-.02-.04-.03-.08.03-.13.03-.01,0-.09-.03-.1-.03,0,0,0-.07.01-.07.02-.02.17,0,.19-.07-.03-.12-.07-.07-.11-.1,0,0,.01-.03,0-.04-.05-.05-.09.03-.11.02,0,0-.08-.07-.09-.08,0-.01,0-.19.02-.21-.11-.04-.16-.1-.21-.2-.13-.27.05-.68.22-.9.11-.14.35-.37.51-.44s.44-.07.57.09c.08.1.15.4.15.53,0,.05-.03.13-.03.15,0,.04.07.05.05.16Z"
      />
      <path
        className="cls-1"
        d="M45.2,24.4c.05-.07.11-.09.16-.15.1-.12.09-.22.25-.3.1-.06.45-.11.56-.08.12.03.21.11.25.23.05.13-.02.22-.03.34-.02.16.01.23-.03.43,0,.04,0,.09,0,.13-.01.02-.16.2-.18.23-.04.04-.16.11-.21.12-.05,0-.11-.04-.12-.03-.01,0-.14.12-.21.14-.04.01-.08,0-.12.02-.06.05-.06.12-.17.11-.09-.01-.08-.07-.03-.13-.02-.02-.04.02-.07.02-.03,0-.05-.05-.06-.05-.01,0-.04.07-.08.04-.07-.05,0-.1-.03-.13s-.09-.03-.12-.07c-.03-.03-.01-.07-.03-.1-.02-.03-.09-.03-.11-.06.02-.05.07-.06.11-.1.06,0,.05-.02.06-.06.01-.06-.01-.05-.01-.06,0-.07.04-.1.07-.15.06-.12.12-.22.19-.33Z"
      />
      <path
        className="cls-1"
        d="M43.73,25.29c-.16,0-.27.1-.4.11-.06,0-.1-.02-.14-.02-.09.01-.18.11-.24.15,0,0-.11.05-.11.05-.02,0-.29-.07-.31-.08-.07-.04-.03-.1-.05-.12-.01-.01-.05-.01-.07-.03-.01-.01,0-.04,0-.06-.06-.13-.08-.21-.12-.36-.05-.23.19-.33.33-.46.1-.09.12-.15.26-.21.16-.07.49-.04.63.07.04.03.13.12.17.16.05.05.18.18.18.25,0,.05-.04.09,0,.19,0,.02.03.04.03.04,0,.03-.07.07-.07.08,0,0,.05.05.05.06,0,.03-.04.04-.05.04,0-.01-.02-.08-.04-.05-.02.03,0,.06.02.08,0,0-.01.02-.02.03-.02.03-.04.06-.06.09Z"
      />
      <path
        className="cls-1"
        d="M46.31,26.14s.07.1.07.14c0,.06-.05.15-.07.21-.01.05,0,.13-.01.17-.01.03-.05.03-.06.07,0,.02,0,.07,0,.09,0,0-.03-.01-.04,0-.02.02-.06.13-.1.17-.1.11-.23.16-.38.19-.05.01-.19.01-.25,0-.08-.02-.31-.14-.35-.21-.03-.05,0-.08-.02-.13-.01-.04-.09-.11-.08-.15,0-.03.04-.06.05-.09,0-.02-.02-.05-.02-.09,0-.04.04-.21.06-.26.04-.12.15-.25.28-.17.03-.03,0-.03,0-.04,0-.03.1-.12.13-.13.02,0,.05,0,.08,0,.16-.07.15-.02.29-.03.02,0,.05-.02.08-.03.14-.02.23-.04.32.11.04.07.02.12.03.18Z"
      />
      <path
        className="cls-1"
        d="M44.19,25.34c-.06.03-.08.13-.15.08l.04-.05s-.07.05-.1.08c-.06.05-.15.03-.22,0,.01-.05.08-.04.09-.06.03-.03.02-.13.09-.06v.05c.02-.05.23-.11.26-.04Z"
      />
      <path
        className="cls-1"
        d="M45.84,25.54s-.15.04-.17.04c-.03,0,0-.03,0-.05.02-.04.05-.04,0-.07.06-.05.15.04.19.03v.05Z"
      />
      <path
        className="cls-1"
        d="M43.9,27.57s.13-.08.15-.07c.12.02.04.05,0,.1-.04-.04-.06.01-.09-.02,0-.01.02-.03,0-.04l-.03.07s-.03-.04-.03-.04Z"
      />
      <path
        className="cls-1"
        d="M45.29,24.1h.06s-.03.02-.04.05c0,.01.05.12-.01.04,0,.04-.06.05-.07.07,0-.06.04-.1.05-.15Z"
      />
      <path
        className="cls-1"
        d="M45.85,25.49s0-.03.03-.02c.03,0,.05.04.08.06,0,.03-.12.08-.08,0,0,0-.02.01-.04.01v-.05Z"
      />
      <path
        className="cls-1"
        d="M43.34,25.64s.04-.11.06-.11c.11.11-.01.05-.06.11Z"
      />
      <path
        className="cls-1"
        d="M43.66,25.49l-.07.07c-.08-.06-.01-.13.07-.07Z"
      />
      <path
        className="cls-1"
        d="M44.37,25.28s0,.04.01.05.01-.01.02-.01c.03,0,.03.03.03.04,0,.01-.19-.03-.09-.09,0,0,.02.01.03.02Z"
      />
      <path
        className="cls-1"
        d="M43.79,25.2c.05.02,0,.09-.06.09.02-.03.04-.06.06-.09Z"
      />
      <path
        className="cls-1"
        d="M45.87,25.6s-.08.03-.1,0c.02-.01.09-.05.1,0Z"
      />
      <path
        className="cls-1"
        d="M43.83,25.15s-.01.02-.02.03c-.02-.02-.04-.05-.02-.08.01-.02.03.04.04.05Z"
      />
      <path className="cls-1" d="M44.9,25s.03-.06.06-.06c0,.04,0,.06-.06.06Z" />
      <path
        className="cls-1"
        d="M43.83,27.54c-.03.05-.02.03-.05.02.03-.06.03-.03.05-.02Z"
      />
      <path
        className="cls-1"
        d="M44.17,27.81s-.07,0-.03-.04c.01.01.04.02.03.04Z"
      />
      <path
        className="cls-1"
        d="M44.74,25.01s0,.03,0,.03c0,0-.02-.02-.03-.02l.03-.02Z"
      />
      <path
        className="cls-1"
        d="M44.66,25.08s-.03,0-.04,0c.01-.03.02-.03.04,0Z"
      />
      <path
        className="cls-1"
        d="M44.07,27.7c-.07.06-.02-.01-.03-.02,0,0,.02.01.03.02Z"
      />
      <path className="cls-1" d="M45.73,25.66h-.01c.03-.07.06-.05.01,0Z" />
      <path
        className="cls-1"
        d="M66.32,21.08s-.05.06-.06.07c0,.01.01.04,0,.05-.01.02-.05,0-.06,0,0,0,.01.15-.03.19-.02.01-.08-.02-.14.03-.02.02.01.07-.03.1-.02.02-.05.01-.06.02-.02.01-.01.04-.03.06-.02.02-.06.01-.09.03s-.03.06-.05.09-.05.02-.07.04c0,0,.01.03,0,.05-.02.04-.06.05-.08.08,0,.01.01.04,0,.07-.03.1-.13.15-.23.15-.04,0-.08-.04-.11-.03-.06.01.04.08.04.09,0,.01-.17.18-.19.21-.02.02-.03.05-.05.07-.05.05-.15.1-.22.1-.16,0-.26-.11-.34-.25-.09-.15-.01-.34.08-.48.02-.04.1-.1.1-.1,0-.03-.04-.05-.04-.08,0-.02.02-.04.03-.06,0-.02-.02-.05,0-.06.02-.02.06-.03.08-.04.01-.01-.03-.06,0-.09s.11,0,.13-.06c0-.02-.08-.15-.08-.16,0-.01.06-.01.07-.06,0-.06-.04-.13-.04-.18,0-.03.02-.14.01-.15,0-.02-.08-.06-.08-.12,0-.06.13-.17.16-.21.02-.03-.01-.07,0-.08.02-.01.04,0,.06-.01.02-.01.03-.05.06-.07.05-.04.11-.01.17-.01.12,0,.2,0,.31.03.1.01.17-.08.26-.09.04,0,.07.03.08.03.02,0,.18-.16.23-.19.13-.09.24-.11.39-.09s.35.14.33.31c0,.04-.04.07-.04.09,0,.03.03.05.03.06,0,0-.03.03-.04.06-.02.05.02.1.02.11,0,.01-.12.14-.14.17-.02-.01-.03,0-.05.02-.03.02-.06.03-.08.05,0,0-.02.01-.02.02-.03,0-.03.03-.09-.03-.04-.05-.05-.13-.1-.02,0,.02.02.13.03.16-.03.02-.03.04-.05.06-.01.02-.04.01,0,.06Z"
      />
      <path
        className="cls-1"
        d="M63.37,18.72c.05.03.08.08.14.09.03.05.07.09.12.12.02.06.08.12.12.17.03.03.1.08.11.11,0,.02-.04.05-.04.08,0,.02.08.15.09.15.06,0,.03-.22.11-.11,0,.03.05.14.08.16v.03s.04.05.05.07c-.03.01-.03.03,0,.04,0,.03,0,.09.03.11.03.02.06-.02.06-.02.04,0,0,.05,0,.07,0,.04.04.09.03.13,0,0-.02.01-.02.02-.04.04.01.08,0,.13,0,.01-.05.08-.05.09,0,0-.06-.03-.07-.03-.02-.03.03-.17-.01-.2-.12,0-.09.05-.12.08,0,0-.03-.02-.03-.01-.06.03,0,.1,0,.11,0,0-.09.06-.1.06-.01,0-.18-.05-.2-.07-.07.1-.14.13-.25.15-.29.05-.65-.22-.82-.44-.11-.15-.27-.43-.3-.61s.05-.44.23-.52c.12-.05.43-.04.55,0,.04.01.11.06.14.06.04,0,.07-.06.17,0Z"
      />
      <path
        className="cls-1"
        d="M63.64,18.89c-.06-.06-.06-.13-.1-.19-.09-.13-.19-.15-.23-.32-.03-.11,0-.46.06-.56.06-.11.16-.17.28-.19.14-.01.21.07.32.12.15.06.23.05.41.14.03.02.09.01.12.04.02.02.16.2.18.23.03.05.06.18.06.24,0,.05-.06.1-.06.11,0,.01.08.17.08.24,0,.04-.03.08,0,.12.03.07.1.09.06.19-.03.08-.09.06-.13,0-.02.02.01.05,0,.07,0,.02-.06.03-.07.04,0,.01.06.06.02.09-.06.05-.1-.02-.13,0s-.06.08-.09.1c-.04.02-.07,0-.1,0-.03.02-.05.08-.09.09-.04-.03-.04-.08-.07-.13.02-.05,0-.05-.04-.07-.06-.03-.05,0-.07,0-.07-.01-.09-.07-.13-.1-.1-.09-.18-.17-.27-.27Z"
      />
      <path
        className="cls-1"
        d="M64.13,20.54c-.03.15.02.29,0,.41,0,.05-.05.09-.05.13,0,.09.06.2.08.27,0,0,.02.12.02.12,0,.02-.14.26-.16.28-.06.05-.1,0-.13.01-.02,0-.02.05-.05.06-.02,0-.04-.01-.06-.01-.14.02-.23.03-.37.02-.23,0-.27-.27-.36-.44-.06-.12-.12-.16-.14-.31-.03-.17.09-.49.23-.59.04-.03.15-.1.2-.13.06-.04.22-.13.29-.11.05.01.07.06.18.06.02,0,.04-.02.05-.02.03,0,.05.09.06.09,0,0,.07-.04.07-.04.02,0,.02.05.03.06-.01,0-.08,0-.06.02.02.02.06.02.08,0,0,0,.01.02.02.02.02.03.05.05.07.08Z"
      />
      <path
        className="cls-1"
        d="M65.61,18.26s.11-.04.15-.03c.06,0,.13.09.19.12.04.02.13.03.16.06.02.02.02.05.05.07.02.02.07,0,.09.03,0,0-.02.03-.01.03.02.03.11.09.14.14.09.12.1.27.09.42,0,.06-.04.19-.07.24-.04.07-.22.26-.29.29-.05.02-.08-.02-.13-.01-.05,0-.13.06-.17.04-.03-.01-.05-.05-.07-.07-.02,0-.06,0-.09,0-.04-.01-.19-.1-.23-.12-.1-.07-.2-.21-.09-.31-.02-.04-.03,0-.04,0-.03,0-.09-.13-.09-.16,0-.03.02-.05.02-.08-.03-.17.01-.15.05-.28,0-.02,0-.06,0-.09.02-.14.02-.23.19-.28.07-.02.13.01.18.01Z"
      />
      <path
        className="cls-1"
        d="M64.29,20.11c.01.06.1.11.04.17l-.04-.05s.03.08.05.12c.03.07,0,.15-.06.21-.05-.02-.02-.09-.03-.11-.02-.04-.12-.05-.04-.1l.04.03s-.04-.27.03-.27Z"
      />
      <path
        className="cls-1"
        d="M64.9,18.57s0,.15,0,.17c-.02.03-.03,0-.04-.01-.03-.03-.02-.06-.07-.01-.03-.07.08-.13.08-.17l.04.03Z"
      />
      <path
        className="cls-1"
        d="M66.37,20.96s-.04-.14-.03-.16c.05-.11.06-.02.1.02-.05.02,0,.06-.04.08-.01,0-.02-.03-.04,0l.06.05s-.04.02-.05.02Z"
      />
      <path
        className="cls-1"
        d="M63.37,18.72v-.07s.03.04.05.05c0,0,.13-.01.04.02.03.02.04.07.05.08-.06,0-.08-.06-.14-.09Z"
      />
      <path
        className="cls-1"
        d="M64.86,18.54s-.02-.02-.01-.03c.02-.02.06-.04.08-.06.03,0,.04.13-.02.08,0,0,0,.02,0,.04l-.04-.03Z"
      />
      <path
        className="cls-1"
        d="M64.36,21.01s-.1-.07-.09-.08c.13-.07.04.02.09.08Z"
      />
      <path
        className="cls-1"
        d="M64.29,20.66l.05.08c-.08.06-.13-.02-.05-.08Z"
      />
      <path
        className="cls-1"
        d="M64.27,19.92s.04,0,.05,0,0-.02,0-.02c0-.03.04-.02.04-.02,0,.01-.07.17-.11.06,0,0,.02-.02.02-.02Z"
      />
      <path
        className="cls-1"
        d="M64.06,20.46s.08.03.07.08c-.02-.03-.05-.05-.07-.08Z"
      />
      <path
        className="cls-1"
        d="M64.97,18.55s0,.09-.02.1c0-.02-.02-.1.02-.1Z"
      />
      <path
        className="cls-1"
        d="M64.01,20.41s.01.02.02.02c-.02.02-.06.02-.08,0-.02-.02.05-.02.06-.02Z"
      />
      <path
        className="cls-1"
        d="M64.14,19.34s-.05-.04-.04-.07c.03.02.06.02.04.07Z"
      />
      <path
        className="cls-1"
        d="M66.32,21.02s.02.03,0,.06c-.05-.04-.02-.03,0-.06Z"
      />
      <path
        className="cls-1"
        d="M66.67,20.76s-.01.07-.05.02c.01,0,.03-.03.05-.02Z"
      />
      <path
        className="cls-1"
        d="M64.11,19.49s.03,0,.03.01c0,0-.02.01-.02.02v-.03Z"
      />
      <path
        className="cls-1"
        d="M64.16,19.59c.03.05,0,.03,0,.04-.02-.02-.02-.03,0-.04Z"
      />
      <path
        className="cls-1"
        d="M66.54,20.83c.05.08-.02.02-.02.02,0,0,.02-.01.02-.02Z"
      />
      <path className="cls-1" d="M64.99,18.7h-.01s-.02-.05.01,0Z" />
      <path
        className="cls-1"
        d="M66.92,7.97s-.08,0-.09.01c-.01,0-.02.04-.03.04-.02,0-.04-.03-.04-.03,0,0-.1.12-.15.11-.02,0-.04-.07-.12-.07-.03,0-.04.06-.1.05-.03,0-.04-.03-.06-.03-.02,0-.04.02-.06.02-.03,0-.05-.04-.09-.04s-.07.03-.1.03-.05-.02-.07-.02c-.01,0-.01.03-.03.03-.04.01-.08,0-.11,0-.02,0-.02.04-.05.05-.09.05-.2.01-.27-.06-.02-.03-.03-.09-.06-.1-.05-.03-.03.09-.03.09-.01,0-.25.01-.29.01-.03,0-.06.02-.09.02-.07,0-.18-.03-.23-.08-.11-.11-.11-.27-.07-.41.05-.17.23-.25.39-.28.04,0,.13,0,.14,0,.02-.01.01-.06.03-.09.01-.01.05-.01.07-.03.02-.01.02-.04.04-.05.03,0,.06.03.09.02.02,0,.02-.06.07-.06s.08.08.13.04c.02-.01.05-.16.05-.17,0,0,.05.04.09,0,.04-.04.07-.12.1-.16.02-.02.11-.09.11-.1,0-.01-.02-.1.03-.14.04-.04.21-.03.26-.04.04,0,.04-.06.05-.06.02,0,.03.03.05.03.03,0,.06-.01.09,0,.06,0,.09.07.13.11.08.08.13.14.2.24.06.08.18.06.24.12.03.03.03.07.04.08.02.01.24.01.3.02.15.03.25.09.35.21s.15.35.01.45c-.03.03-.07.02-.09.03-.03.02-.01.06-.02.07,0,0-.04,0-.07.01-.05.02-.06.08-.06.09,0,0-.18.01-.22.02,0-.02-.03-.02-.05-.02-.03,0-.06-.02-.09-.02-.01,0-.02,0-.03,0-.02-.02-.05,0-.04-.08,0-.06.06-.13-.05-.09-.02,0-.08.11-.09.14-.03,0-.05,0-.08.01-.02,0-.04-.02-.03.04Z"
      />
      <path
        className="cls-1"
        d="M66.46,4.23c.02.06,0,.11.04.16,0,.06,0,.12,0,.17-.03.05-.03.14-.03.21,0,.04.02.12,0,.15,0,.02-.06,0-.08.03-.01.02-.05.17-.04.17.04.05.17-.13.16,0-.02.02-.06.14-.06.17l-.02.03s-.02.06-.02.08c-.03,0-.04,0-.03.03-.02.02-.06.07-.05.1,0,.03.06.03.06.03.02.03-.04.03-.05.05-.02.03-.03.09-.07.11,0,0-.02,0-.03,0-.05,0-.05.07-.1.09-.01,0-.09.03-.1.02,0,0-.03-.06-.03-.07,0-.03.14-.09.13-.15-.08-.09-.1-.02-.14-.03,0,0,0-.03-.01-.03-.06-.02-.06.07-.09.07,0,0-.11-.02-.12-.03-.01,0-.09-.16-.09-.19-.12.02-.19,0-.28-.07-.25-.17-.31-.61-.27-.89.02-.18.11-.5.21-.64s.34-.28.53-.21c.12.05.33.27.4.38.02.04.04.12.05.14.03.03.09,0,.12.12Z"
      />
      <path
        className="cls-1"
        d="M66.54,4.53c0-.08.05-.13.06-.21.03-.15-.03-.24.06-.39.06-.1.33-.32.44-.35.12-.04.23-.01.33.07.11.09.1.2.14.31.06.15.13.19.19.39.01.04.05.07.06.11,0,.03-.03.25-.04.29-.01.05-.08.17-.12.21-.04.03-.11.03-.12.03-.01,0-.06.17-.11.23-.03.03-.07.03-.09.08-.03.07,0,.14-.09.18-.08.04-.11-.02-.09-.1-.03,0-.02.04-.05.05-.02.01-.07-.02-.08-.01,0,0,0,.08-.04.08-.08,0-.05-.08-.09-.1s-.09.02-.14,0c-.04,0-.05-.06-.08-.07-.04-.01-.09.02-.13,0,0-.05.03-.09.04-.14.05-.02.03-.04.02-.08-.02-.06-.04-.04-.04-.05-.04-.06-.01-.11-.02-.17-.01-.13,0-.25,0-.38Z"
      />
      <path
        className="cls-1"
        d="M65.73,6.05c-.13.09-.19.22-.29.3-.04.03-.1.03-.13.05-.07.06-.1.18-.13.25,0,0-.07.1-.07.1-.01.01-.28.08-.31.08-.08,0-.08-.07-.1-.08-.02,0-.05.02-.08,0-.02,0-.02-.04-.03-.05-.12-.09-.18-.14-.28-.25-.16-.17,0-.38.05-.56.04-.13.03-.19.12-.32.1-.14.41-.28.58-.26.05,0,.18.04.23.05.07.02.25.06.28.12.03.05.01.09.09.17.01.01.04.02.05.02.02.03-.03.1-.02.11,0,0,.07.02.08.02.01.02-.02.05-.02.06,0,0-.06-.05-.06-.03,0,.03.03.05.06.06,0,.01,0,.02,0,.03,0,.04,0,.07,0,.11Z"
      />
      <path
        className="cls-1"
        d="M68.38,5.47s.11.05.13.08c.04.05.03.16.05.22.01.05.07.11.08.15,0,.03-.02.05-.02.09,0,.03.04.05.04.08,0,0-.03,0-.03.02,0,.03.01.14,0,.2-.03.15-.12.26-.23.36-.04.04-.16.11-.21.12-.08.02-.34.04-.41,0-.05-.03-.05-.07-.08-.1-.03-.03-.14-.05-.15-.09-.01-.03,0-.07,0-.1,0-.02-.04-.04-.06-.07-.02-.04-.07-.2-.08-.25-.03-.12,0-.29.15-.29.02-.04-.02-.03-.02-.04-.02-.03.02-.15.05-.18.02-.02.05-.02.06-.04.1-.14.11-.1.23-.17.02-.01.04-.05.06-.07.11-.09.18-.15.33-.07.07.04.08.1.12.14Z"
      />
      <path
        className="cls-1"
        d="M66.14,5.86c-.03.05,0,.15-.09.15v-.06s-.03.08-.04.12c-.03.08-.11.1-.19.11-.02-.05.04-.08.05-.1.01-.04-.05-.12.04-.1v.05c.01-.06.17-.22.23-.17Z"
      />
      <path
        className="cls-1"
        d="M67.66,5.19s-.11.11-.13.12c-.03.01-.02-.02-.02-.04,0-.04.03-.06-.04-.06.03-.07.15-.04.18-.07v.05Z"
      />
      <path
        className="cls-1"
        d="M67.03,7.92s.07-.13.09-.14c.11-.04.06.03.05.09-.05-.02-.04.04-.09.03-.01,0,0-.04-.02-.03v.08s-.03-.02-.04-.02Z"
      />
      <path
        className="cls-1"
        d="M66.46,4.23l.05-.04s0,.05,0,.07c0,.01.1.08.01.04.01.04-.02.08-.02.09-.03-.05-.02-.1-.04-.16Z"
      />
      <path
        className="cls-1"
        d="M67.65,5.14s0-.03.01-.03c.03,0,.07.01.1,0,.02.02-.06.13-.07.04,0,0-.01.02-.03.03v-.05Z"
      />
      <path
        className="cls-1"
        d="M65.57,6.55s-.02-.12,0-.13c.15.04.01.05,0,.13Z"
      />
      <path className="cls-1" d="M65.76,6.25l-.02.09c-.1-.01-.08-.11.02-.09Z" />
      <path
        className="cls-1"
        d="M66.26,5.71s.03.03.04.03,0-.02,0-.02c.02-.02.05.01.05.02,0,.01-.17.07-.12-.03,0,0,.02,0,.03,0Z"
      />
      <path
        className="cls-1"
        d="M65.73,5.94c.05,0,.04.08,0,.11,0-.04,0-.07,0-.11Z"
      />
      <path
        className="cls-1"
        d="M67.72,5.22s-.06.07-.08.06c0-.02.06-.09.08-.06Z"
      />
      <path
        className="cls-1"
        d="M65.74,5.88s0,.02,0,.03c-.03,0-.06-.03-.06-.06,0-.03.05.02.06.03Z"
      />
      <path
        className="cls-1"
        d="M66.58,5.2s0-.07.02-.08c.01.03.03.05-.02.08Z"
      />
      <path
        className="cls-1"
        d="M66.95,7.93c0,.06,0,.04-.03.04,0-.06,0-.04.03-.04Z"
      />
      <path
        className="cls-1"
        d="M67.38,7.99s-.06.04-.05-.02c.02,0,.04,0,.05.02Z"
      />
      <path
        className="cls-1"
        d="M66.45,5.29s.02.02.01.03c0,0-.03,0-.03,0l.02-.03Z"
      />
      <path
        className="cls-1"
        d="M66.41,5.4c-.02.06-.02.02-.03.03,0-.03,0-.04.03-.03Z"
      />
      <path
        className="cls-1"
        d="M67.25,7.95c-.02.09-.03,0-.03,0,.01,0,.02,0,.03,0Z"
      />
      <path className="cls-1" d="M67.63,5.34h-.02c0-.07.03-.06.02,0Z" />
      <path
        className="cls-1"
        d="M78.44,7.86s-.06-.04-.08-.04c-.01,0-.04.02-.05.01-.02,0-.01-.05-.01-.05,0,0-.15.04-.19,0-.02-.02,0-.08-.05-.13-.03-.02-.06.02-.11-.02-.02-.02-.02-.05-.03-.06-.01-.01-.05,0-.07-.02-.03-.02-.02-.06-.05-.09s-.07-.02-.09-.04-.03-.05-.05-.06c0,0-.03.02-.04,0-.04-.01-.06-.05-.09-.06-.01,0-.04.02-.07.01-.1-.01-.17-.11-.18-.21,0-.04.02-.09.01-.11-.02-.05-.07.06-.08.06-.01,0-.2-.14-.24-.16-.02-.02-.06-.02-.08-.03-.06-.04-.12-.13-.13-.2-.02-.16.07-.28.19-.37.14-.11.34-.06.49,0,.04.02.11.08.12.08.03,0,.05-.04.07-.05.02,0,.05.02.07.02.02,0,.04-.02.06-.02.02.01.04.06.06.07.01,0,.05-.03.09,0s.02.11.08.12c.02,0,.13-.1.14-.1.01,0,.02.06.06.06.06,0,.12-.06.17-.07.03,0,.14,0,.15,0,.01,0,.04-.09.11-.1.06,0,.18.1.23.12.04.02.07-.02.08-.01.02.02,0,.04.02.05.02.02.05.03.08.05.04.04.03.11.04.16.02.12.02.19.02.31,0,.1.1.16.12.24,0,.04-.02.08-.02.08,0,.02.19.16.22.2.1.11.14.22.15.38s-.09.37-.26.37c-.04,0-.07-.03-.09-.03-.03,0-.05.04-.06.04,0,0-.03-.03-.06-.03-.05,0-.09.03-.1.03-.01,0-.15-.1-.18-.12,0-.02-.01-.03-.03-.04-.02-.02-.04-.05-.06-.07,0,0-.02-.01-.02-.02,0-.03-.04-.03.02-.09.04-.05.13-.07,0-.1-.02,0-.13.04-.16.06-.02-.02-.04-.03-.07-.04-.02,0-.02-.04-.05.01Z"
      />
      <path
        className="cls-1"
        d="M80.33,4.59c-.02.06-.07.09-.07.15-.04.04-.08.09-.1.14-.06.03-.11.1-.15.15-.03.03-.06.11-.09.13-.02.01-.05-.04-.08-.03-.02,0-.14.1-.14.11,0,.06.22,0,.13.09-.03,0-.13.08-.15.1h-.03s-.05.05-.06.06c-.02-.02-.03-.02-.04,0-.03,0-.09.02-.1.05-.01.03.03.06.03.06,0,.04-.05,0-.07,0-.04,0-.08.05-.12.05,0,0-.02-.02-.02-.02-.04-.03-.08.02-.13.01-.01,0-.09-.04-.09-.04,0,0,.02-.07.02-.07.02-.02.17,0,.2-.04-.01-.12-.07-.08-.1-.11,0,0,.01-.03,0-.03-.04-.05-.09.02-.11,0,0,0-.07-.08-.08-.09,0-.01.03-.18.04-.21-.1-.06-.15-.11-.19-.22-.1-.28.12-.68.31-.87.13-.13.39-.33.56-.39s.44-.02.55.15c.07.11.11.42.09.55,0,.05-.04.12-.04.15,0,.04.07.06.03.17Z"
      />
      <path
        className="cls-1"
        d="M80.21,4.87c.05-.07.12-.08.17-.13.12-.11.12-.21.28-.27.11-.04.45-.06.56-.02.12.04.2.13.23.25.03.14-.04.22-.07.34-.04.16-.01.23-.08.42-.01.04,0,.09-.02.12-.01.02-.18.19-.2.21-.04.04-.17.09-.22.09-.05,0-.11-.05-.12-.05-.01,0-.15.1-.23.11-.04,0-.08-.02-.12.01-.07.04-.07.11-.18.09-.09-.02-.07-.08-.02-.13-.02-.02-.04.02-.07.01-.03,0-.04-.06-.05-.06-.01,0-.05.07-.08.03-.06-.06,0-.1-.01-.13s-.08-.04-.11-.08c-.03-.03,0-.07-.02-.1-.02-.03-.08-.04-.11-.07.03-.05.08-.06.12-.09.05.01.05-.01.06-.05.02-.06,0-.05,0-.07,0-.07.05-.1.08-.14.07-.11.15-.21.23-.31Z"
      />
      <path
        className="cls-1"
        d="M78.65,5.6c-.16-.01-.28.07-.41.07-.06,0-.1-.04-.13-.03-.09,0-.19.09-.26.12,0,0-.11.04-.12.04-.02,0-.28-.1-.3-.12-.06-.05-.02-.1-.03-.12-.01-.01-.05-.02-.06-.04-.01-.02,0-.04,0-.06-.04-.14-.06-.22-.08-.37-.03-.23.22-.31.38-.42.11-.08.14-.14.28-.18.16-.05.49.02.62.14.03.03.12.14.15.18.04.05.16.2.16.26,0,.05-.04.08-.03.19,0,.02.03.04.03.05,0,.03-.08.06-.08.07,0,0,.05.06.05.06,0,.03-.05.03-.05.04,0-.01-.02-.08-.03-.06-.02.02,0,.06.01.08,0,0-.01.02-.02.02-.02.03-.05.06-.07.08Z"
      />
      <path
        className="cls-1"
        d="M81.12,6.73s.05.11.05.15c0,.06-.07.15-.09.21-.02.05,0,.13-.03.17-.02.02-.05.03-.06.06-.01.02,0,.07-.02.09,0,0-.03-.01-.04,0-.03.02-.07.12-.12.16-.11.1-.25.13-.4.15-.06,0-.19,0-.24-.03-.08-.03-.29-.17-.33-.25-.03-.05,0-.08,0-.13,0-.04-.08-.12-.07-.16,0-.03.05-.05.06-.08,0-.02-.01-.05,0-.09,0-.04.07-.2.09-.25.05-.11.18-.23.29-.14.04-.02,0-.03,0-.04,0-.03.11-.11.15-.12.02,0,.05.01.08,0,.16-.06.15,0,.29,0,.02,0,.06-.02.09-.02.14,0,.23-.01.31.14.03.07,0,.13.01.18Z"
      />
      <path
        className="cls-1"
        d="M79.1,5.7c-.06.02-.09.12-.16.07l.04-.05s-.07.04-.11.07c-.07.04-.15.02-.22-.02.02-.05.08-.04.1-.05.03-.03.03-.12.09-.05l-.02.05c.04-.05.26-.08.28,0Z"
      />
      <path
        className="cls-1"
        d="M80.71,6.07s-.15.02-.17.02c-.03-.01,0-.03,0-.04.02-.04.06-.03,0-.07.07-.04.14.06.18.05l-.02.05Z"
      />
      <path
        className="cls-1"
        d="M78.57,7.88s.14-.06.16-.06c.12.03.03.05,0,.1-.03-.05-.06,0-.09-.03,0-.01.03-.03,0-.04l-.04.07s-.02-.04-.03-.04Z"
      />
      <path
        className="cls-1"
        d="M80.33,4.59h.07s-.03.03-.04.05c0,0,.03.12-.02.04-.01.04-.06.05-.07.06,0-.06.05-.09.07-.15Z"
      />
      <path
        className="cls-1"
        d="M80.73,6.03s.01-.03.03-.02c.02.01.05.05.07.07,0,.03-.13.06-.08-.01,0,0-.02,0-.04,0l.02-.05Z"
      />
      <path
        className="cls-1"
        d="M78.22,5.91s.06-.11.07-.1c.09.12-.02.04-.07.1Z"
      />
      <path className="cls-1" d="M78.55,5.78l-.07.06c-.07-.07,0-.13.07-.06Z" />
      <path
        className="cls-1"
        d="M79.28,5.65s0,.04,0,.05.01,0,.02-.01c.03,0,.03.04.03.04,0,.01-.18-.05-.08-.1,0,0,.02.01.02.02Z"
      />
      <path
        className="cls-1"
        d="M78.72,5.52s-.02.09-.07.08c.02-.03.05-.06.07-.08Z"
      />
      <path className="cls-1" d="M80.74,6.13s-.08.02-.1,0c.02-.01.1-.04.1,0Z" />
      <path
        className="cls-1"
        d="M78.76,5.47s-.01.02-.02.02c-.02-.02-.03-.06-.01-.08.02-.02.03.05.03.06Z"
      />
      <path
        className="cls-1"
        d="M79.84,5.44s.03-.06.06-.05c-.01.03,0,.06-.06.05Z"
      />
      <path
        className="cls-1"
        d="M78.5,7.84c-.04.05-.03.03-.05.01.03-.05.03-.02.05-.01Z"
      />
      <path
        className="cls-1"
        d="M78.81,8.15s-.07,0-.03-.04c.01.01.03.02.03.04Z"
      />
      <path
        className="cls-1"
        d="M79.68,5.43s0,.03,0,.03c0,0-.02-.02-.02-.02h.03Z"
      />
      <path
        className="cls-1"
        d="M79.59,5.49s-.03,0-.04,0c.01-.02.03-.03.04,0Z"
      />
      <path
        className="cls-1"
        d="M78.72,8.03c-.07.06-.02-.02-.02-.02,0,0,.02.01.02.02Z"
      />
      <path className="cls-1" d="M80.6,6.18h-.01c.04-.06.06-.04.01,0Z" />
      <path
        className="cls-1"
        d="M72,32.24s-.08,0-.09,0c-.01,0-.02.04-.03.04-.02,0-.04-.04-.04-.04,0,0-.11.11-.16.11-.02,0-.04-.07-.12-.08-.03,0-.04.05-.1.04-.03,0-.04-.03-.06-.03-.02,0-.04.02-.06.02-.03,0-.05-.04-.09-.05s-.07.02-.1.02-.05-.02-.07-.03c-.01,0-.01.03-.03.03-.04.01-.08,0-.11,0-.02,0-.02.04-.05.05-.09.04-.2,0-.26-.07-.02-.03-.03-.09-.05-.1-.05-.03-.03.09-.04.09-.01,0-.25,0-.29,0-.03,0-.06.02-.09.02-.07,0-.18-.04-.22-.1-.1-.12-.09-.27-.04-.42.06-.17.25-.24.41-.26.04,0,.13,0,.14,0,.02-.01.02-.06.03-.08.01-.01.05,0,.07-.02.02-.01.02-.04.04-.04.03,0,.06.03.09.03.02,0,.03-.06.07-.05s.08.08.13.05c.02-.01.06-.16.06-.17,0,0,.05.04.09.01.05-.04.07-.11.11-.15.02-.02.12-.08.12-.09,0-.01-.01-.1.04-.14.05-.04.21-.01.26-.02.04,0,.05-.05.06-.05.02,0,.03.03.05.03.03,0,.06,0,.09,0,.06.01.09.08.12.12.08.09.12.15.19.25.05.08.17.07.23.13.03.03.03.07.03.08.02.02.24.03.3.04.15.04.24.11.33.23s.13.36-.02.45c-.04.02-.07.02-.09.03-.03.02-.02.06-.03.07,0,0-.04,0-.07,0-.05.02-.06.08-.07.08,0,0-.18,0-.22,0,0-.02-.03-.02-.04-.02-.03,0-.06-.02-.09-.03,0,0-.02,0-.03,0-.02-.02-.05,0-.04-.08,0-.06.07-.13-.05-.09-.02,0-.08.11-.1.13-.03,0-.05,0-.08,0-.03,0-.04-.02-.04.04Z"
      />
      <path
        className="cls-1"
        d="M71.79,28.47c.01.06,0,.11.03.16-.01.06-.02.12,0,.17-.03.05-.04.14-.04.21,0,.04,0,.12,0,.15,0,.02-.06,0-.08.02-.01.02-.06.16-.05.17.04.05.18-.12.16,0-.02.02-.07.13-.07.16l-.02.03s-.02.06-.03.08c-.03,0-.04,0-.04.03-.02.02-.06.07-.06.09,0,.03.06.03.06.03.02.03-.04.03-.05.05-.03.02-.04.08-.08.11,0,0-.02,0-.03,0-.05,0-.05.06-.1.08-.01,0-.1.02-.1.02,0,0-.02-.06-.02-.07,0-.03.15-.08.14-.15-.08-.09-.1-.03-.14-.04,0,0,0-.03-.01-.03-.06-.02-.07.07-.09.07,0,0-.11-.03-.12-.04-.01,0-.08-.17-.08-.2-.12.01-.19-.02-.28-.09-.24-.18-.27-.63-.21-.9.04-.18.14-.49.26-.63s.36-.26.55-.18c.12.05.32.29.38.41.02.04.03.13.04.15.02.04.09.02.12.13Z"
      />
      <path
        className="cls-1"
        d="M71.85,28.78c0-.08.06-.13.07-.2.04-.15-.02-.24.08-.38.07-.1.35-.3.46-.32.12-.03.23,0,.33.09.1.1.08.2.12.32.05.15.12.2.17.4.01.04.05.08.05.12,0,.03-.05.25-.06.29-.01.05-.09.17-.14.2-.04.03-.11.02-.13.03-.01,0-.07.17-.13.22-.03.03-.08.03-.1.08-.03.07,0,.14-.1.17-.09.03-.1-.03-.09-.1-.03,0-.03.04-.05.05-.02,0-.07-.03-.08-.02,0,0,0,.08-.05.07-.08-.01-.05-.09-.08-.11s-.09,0-.14,0c-.04-.01-.05-.06-.07-.07-.03-.01-.09.01-.13,0,0-.05.03-.09.05-.13.05-.02.03-.04.03-.08-.02-.06-.03-.04-.04-.05-.04-.06,0-.11,0-.17,0-.13,0-.25.02-.38Z"
      />
      <path
        className="cls-1"
        d="M70.94,30.24c-.14.08-.2.21-.31.28-.05.03-.1.02-.13.05-.07.05-.11.18-.15.24,0,0-.07.09-.08.1-.01,0-.29.07-.31.06-.08,0-.07-.08-.1-.09-.02,0-.05.01-.08,0-.02,0-.02-.04-.03-.05-.11-.09-.17-.15-.27-.26-.15-.18.02-.38.09-.56.05-.12.04-.19.14-.31.11-.13.42-.26.59-.22.05,0,.18.05.23.06.07.02.24.08.28.14.03.05,0,.09.08.18.01.01.04.02.05.03.01.03-.03.1-.03.1,0,0,.07.02.07.03.01.02-.02.05-.02.06,0,0-.06-.06-.06-.03,0,.03.03.06.05.06,0,.01,0,.02,0,.03,0,.04,0,.07-.01.11Z"
      />
      <path
        className="cls-1"
        d="M73.62,29.83s.1.06.12.09c.03.05.02.16.04.22.01.05.07.11.07.16,0,.03-.02.05-.02.08,0,.03.04.06.03.09,0,0-.03,0-.03.01-.01.03,0,.14-.01.2-.04.15-.14.25-.25.34-.04.03-.17.1-.22.11-.08.02-.34.01-.41-.03-.05-.03-.04-.07-.08-.11-.03-.03-.13-.06-.14-.1-.01-.03,0-.07,0-.1,0-.02-.04-.04-.05-.07-.02-.04-.06-.21-.06-.26-.02-.12.02-.29.17-.28.02-.04-.02-.03-.02-.04-.02-.03.03-.15.06-.18.02-.02.05-.02.07-.04.11-.14.12-.09.24-.15.02-.01.04-.05.06-.06.12-.08.19-.14.34-.05.07.04.07.1.11.14Z"
      />
      <path
        className="cls-1"
        d="M71.37,30.08c-.04.05-.01.15-.1.14v-.06s-.03.08-.05.12c-.03.07-.12.1-.19.1-.01-.05.05-.07.06-.1.01-.04-.04-.12.05-.09v.05c.01-.06.18-.21.23-.16Z"
      />
      <path
        className="cls-1"
        d="M72.93,29.51s-.11.1-.13.11c-.03,0-.02-.03-.02-.04,0-.04.03-.06-.04-.06.03-.07.15-.03.18-.05v.05Z"
      />
      <path
        className="cls-1"
        d="M72.12,32.19s.08-.13.1-.13c.12-.03.06.03.05.09-.05-.02-.05.04-.09.02-.01,0,0-.04-.02-.03v.08s-.03-.02-.04-.02Z"
      />
      <path
        className="cls-1"
        d="M71.79,28.47l.05-.04s-.01.05,0,.07c0,.01.1.09,0,.04.01.04-.02.07-.03.09-.03-.05-.01-.1-.03-.16Z"
      />
      <path
        className="cls-1"
        d="M72.92,29.46s0-.03.01-.03c.03,0,.07.01.1.01.02.02-.07.12-.08.04,0,0-.02.02-.03.03v-.05Z"
      />
      <path
        className="cls-1"
        d="M70.75,30.73s-.01-.12,0-.13c.14.05.01.05,0,.13Z"
      />
      <path
        className="cls-1"
        d="M70.96,30.45l-.03.09c-.1-.02-.07-.11.03-.09Z"
      />
      <path
        className="cls-1"
        d="M71.5,29.94s.02.03.03.04,0-.02.01-.02c.02-.02.04.01.04.02,0,.01-.18.06-.12-.04,0,0,.02,0,.03,0Z"
      />
      <path
        className="cls-1"
        d="M70.95,30.13c.06,0,.03.08-.01.11,0-.04,0-.07.01-.11Z"
      />
      <path
        className="cls-1"
        d="M72.98,29.55s-.06.06-.09.05c0-.02.06-.08.09-.05Z"
      />
      <path
        className="cls-1"
        d="M70.96,30.07s0,.02,0,.03c-.03,0-.06-.03-.05-.06,0-.03.05.02.06.03Z"
      />
      <path
        className="cls-1"
        d="M71.85,29.45s0-.07.03-.08c0,.03.03.06-.03.08Z"
      />
      <path
        className="cls-1"
        d="M72.04,32.2c0,.06,0,.04-.04.04,0-.06.01-.04.04-.04Z"
      />
      <path
        className="cls-1"
        d="M72.47,32.29s-.06.04-.04-.02c.02,0,.04,0,.04.02Z"
      />
      <path
        className="cls-1"
        d="M71.71,29.53s.02.02.01.03c0,0-.03,0-.03,0l.02-.03Z"
      />
      <path
        className="cls-1"
        d="M71.67,29.63c-.02.06-.02.02-.04.03,0-.03,0-.04.04-.03Z"
      />
      <path
        className="cls-1"
        d="M72.33,32.24c-.03.09-.03,0-.03,0,.01,0,.02,0,.03,0Z"
      />
      <path className="cls-1" d="M72.89,29.66h-.02c0-.07.03-.06.02,0Z" />
      <path
        className="cls-1"
        d="M58.1,32.05s-.07-.01-.09,0c-.01,0-.03.03-.04.03-.02,0-.03-.04-.04-.04,0,0-.12.09-.17.08-.02,0-.02-.08-.1-.1-.03,0-.05.05-.11.03-.03,0-.04-.03-.05-.04-.02,0-.04.01-.07,0-.03,0-.04-.05-.08-.06s-.07,0-.1,0-.05-.03-.07-.04c0,0-.02.03-.04.03-.04,0-.08-.02-.11-.02-.02,0-.03.03-.06.04-.1.03-.2-.03-.25-.12-.02-.03-.01-.09-.03-.11-.04-.04-.04.08-.05.08-.01,0-.24-.04-.28-.05-.03,0-.06,0-.09,0-.07-.02-.17-.07-.2-.13-.08-.13-.04-.28.03-.42.08-.16.28-.19.45-.19.04,0,.13.03.14.03.03,0,.03-.06.05-.08.01-.01.05,0,.07,0,.02,0,.03-.04.05-.04.03,0,.06.04.08.04.02,0,.03-.05.08-.04s.06.09.12.07c.02,0,.08-.15.09-.15,0,0,.04.05.08.03.05-.03.09-.1.13-.13.02-.02.13-.06.13-.07.01-.01,0-.1.06-.13.05-.03.21.02.26.02.04,0,.05-.05.07-.04.02,0,.03.03.04.04.02.01.06,0,.09.01.06.02.07.09.1.14.06.1.1.17.14.28.04.09.16.1.21.17.03.03.01.08.02.08.02.02.23.07.29.09.14.06.22.15.29.28s.07.37-.09.44c-.04.02-.07,0-.09.01-.03.01-.03.06-.04.06,0,0-.04-.01-.07,0-.05.01-.07.07-.08.07,0,0-.18-.03-.22-.03,0-.02-.03-.02-.04-.03-.03-.01-.06-.03-.08-.04,0,0-.02,0-.03,0-.01-.02-.05,0-.02-.09.02-.06.09-.11-.03-.1-.02,0-.1.09-.12.11-.03-.01-.05,0-.08,0-.03,0-.03-.03-.04.04Z"
      />
      <path
        className="cls-1"
        d="M58.52,28.3c0,.06-.02.11,0,.16-.02.05-.04.11-.04.17-.04.05-.06.13-.08.2-.01.04-.01.12-.03.15-.01.02-.06-.01-.09,0-.02.01-.09.15-.08.16.03.05.2-.09.15.03-.02.02-.09.12-.1.15l-.02.03s-.03.06-.04.07c-.03-.01-.04,0-.04.02-.03.01-.07.05-.07.08,0,.03.05.04.05.04.02.03-.04.02-.06.04-.03.02-.05.08-.09.09,0,0-.02,0-.03,0-.05-.01-.06.05-.11.06-.01,0-.1,0-.1,0,0,0-.01-.07-.01-.07.01-.03.16-.06.16-.12-.06-.1-.09-.05-.13-.06,0,0,0-.03,0-.04-.06-.03-.08.05-.1.05,0,0-.1-.05-.11-.05,0,0-.05-.18-.05-.21-.12,0-.18-.05-.26-.13-.2-.22-.16-.67-.06-.92.06-.17.22-.46.36-.58s.4-.2.57-.08c.11.07.26.34.3.46.01.04,0,.13.02.15.02.04.09.03.09.14Z"
      />
      <path
        className="cls-1"
        d="M58.52,28.61c.02-.08.08-.12.11-.19.06-.14.02-.24.14-.36.08-.08.39-.24.51-.25.13,0,.23.04.31.14.09.11.05.22.07.34.03.16.08.22.1.42,0,.04.04.08.03.12,0,.03-.09.24-.1.28-.02.05-.12.15-.17.18-.04.02-.12,0-.13,0-.01,0-.1.15-.16.2-.03.02-.08.02-.11.06-.04.06-.02.13-.13.15-.09.02-.1-.04-.07-.12-.03,0-.03.03-.06.04-.03,0-.06-.04-.07-.03-.01,0-.02.08-.06.06-.08-.03-.03-.09-.06-.12s-.09,0-.14-.03c-.04-.02-.04-.07-.06-.08-.03-.02-.09,0-.13-.03,0-.05.05-.08.07-.12.06,0,.04-.03.04-.07,0-.06-.03-.05-.03-.06-.03-.07,0-.11.02-.17.02-.13.05-.25.08-.37Z"
      />
      <path
        className="cls-1"
        d="M57.38,29.9c-.15.05-.23.17-.35.22-.05.02-.1,0-.14.02-.08.04-.14.16-.18.22,0,0-.09.08-.09.08-.01,0-.3.02-.32.01-.08-.02-.06-.09-.08-.1-.02,0-.05,0-.07-.01-.02-.01,0-.04-.02-.05-.09-.11-.14-.18-.22-.3-.12-.2.08-.37.18-.53.07-.11.07-.18.19-.28.13-.11.46-.18.62-.12.04.02.16.08.21.1.06.03.23.12.25.18.02.05,0,.09.05.19,0,.01.04.03.04.03,0,.03-.05.09-.04.1,0,0,.07.03.07.04,0,.02-.03.05-.03.05,0-.01-.05-.07-.05-.04,0,.03.02.06.04.07,0,0,0,.02,0,.03-.01.03-.02.07-.03.1Z"
      />
      <path
        className="cls-1"
        d="M60.1,29.94s.09.08.11.11c.03.06,0,.16,0,.22,0,.05.05.12.04.17,0,.03-.03.05-.03.08,0,.03.03.06.02.09,0,0-.03,0-.04,0-.02.03-.02.14-.04.2-.06.14-.17.22-.3.29-.05.03-.18.07-.24.07-.08,0-.34-.04-.4-.09-.04-.04-.03-.08-.06-.12-.03-.04-.12-.08-.13-.12,0-.03.02-.07.02-.1,0-.02-.03-.04-.04-.08-.01-.04-.02-.21-.02-.26,0-.12.07-.28.21-.24.02-.04-.01-.03-.02-.04-.01-.03.06-.14.09-.16.02-.01.05,0,.07-.03.13-.12.13-.07.26-.11.02,0,.05-.04.07-.05.13-.06.21-.11.34,0,.06.05.06.11.09.16Z"
      />
      <path
        className="cls-1"
        d="M57.83,29.81s-.03.15-.12.13l.02-.06c-.05,0-.05.07-.07.11-.05.07-.13.08-.21.07,0-.05.06-.06.07-.09.02-.04-.02-.13.06-.08v.05c.02-.06.2-.18.25-.12Z"
      />
      <path
        className="cls-1"
        d="M59.46,29.5s-.13.08-.15.08c-.04,0-.01-.03-.01-.04,0-.04.04-.05-.03-.07.04-.07.15,0,.19-.02v.05Z"
      />
      <path
        className="cls-1"
        d="M58.23,32.02s.1-.11.12-.11c.12-.02.05.04.03.1-.05-.03-.05.03-.09,0-.01,0,.01-.04-.01-.04v.08s-.04-.03-.05-.03Z"
      />
      <path
        className="cls-1"
        d="M58.52,28.3l.06-.03s-.02.04-.02.07c0,.01.08.1,0,.04,0,.04-.04.07-.04.08-.02-.05,0-.1,0-.16Z"
      />
      <path
        className="cls-1"
        d="M59.46,29.45s0-.03.02-.03c.03,0,.06.03.09.03.01.03-.09.11-.08.02,0,0-.02.02-.03.02v-.05Z"
      />
      <path
        className="cls-1"
        d="M57.11,30.36s0-.12.02-.12c.13.07,0,.05-.02.12Z"
      />
      <path
        className="cls-1"
        d="M57.37,30.11l-.04.08c-.09-.04-.05-.12.04-.08Z"
      />
      <path
        className="cls-1"
        d="M57.99,29.7s.02.04.03.04,0-.01.01-.02c.03-.02.04.02.04.03,0,.01-.18.03-.11-.06,0,0,.02,0,.03,0Z"
      />
      <path
        className="cls-1"
        d="M57.42,29.8c.05,0,.02.09-.03.1.01-.03.02-.07.03-.1Z"
      />
      <path
        className="cls-1"
        d="M59.51,29.55s-.07.05-.09.04c.01-.02.07-.07.09-.04Z"
      />
      <path
        className="cls-1"
        d="M57.43,29.74s0,.02,0,.03c-.03-.01-.05-.04-.04-.07,0-.03.05.03.05.04Z"
      />
      <path
        className="cls-1"
        d="M58.41,29.27s0-.07.04-.07c0,.04.02.06-.04.07Z"
      />
      <path
        className="cls-1"
        d="M58.15,32.01c-.01.06-.01.04-.04.04.01-.06.02-.03.04-.04Z"
      />
      <path
        className="cls-1"
        d="M58.56,32.17s-.06.03-.04-.03c.01,0,.04,0,.04.03Z"
      />
      <path
        className="cls-1"
        d="M58.26,29.33s.02.03,0,.03c0,0-.02-.01-.03,0l.02-.03Z"
      />
      <path
        className="cls-1"
        d="M58.2,29.42c-.03.05-.02.01-.04.02,0-.03.01-.03.04-.02Z"
      />
      <path
        className="cls-1"
        d="M58.43,32.1c-.04.08-.03,0-.03,0,0,0,.02,0,.03,0Z"
      />
      <path className="cls-1" d="M59.4,29.65h-.01c.01-.07.04-.06.01,0Z" />
      <path
        className="cls-1"
        d="M56.78,8.38c-.02-.38.23-.76.59-.91.06-.03.13-.04.2-.03.12.02.21.12.24.23s.03.23.01.35c-.1.9-.43,1.77-.95,2.51-.69-.69-1.12-1.64-1.19-2.61,0-.12-.01-.24.03-.34s.15-.2.27-.18c.1.01.17.09.24.16.2.23.37.49.51.77"
      />
      <path
        className="cls-1"
        d="M57.01,8.38s0-.06,0-.09c0-.02,0-.03,0-.05,0,.04,0,0,0,0,0-.03.01-.06.02-.09,0-.01,0-.03.01-.04,0,0,.03-.06.01-.03.06-.13.11-.19.21-.28,0,0,.03-.03,0,0,.01,0,.02-.02.04-.03.03-.02.05-.03.08-.05.01,0,.03-.01.04-.02,0,0-.04.01.01,0,.02,0,.03-.01.05-.02h.03s-.01,0,0,0h.01s-.02,0,0,0c-.02-.02,0,0,0,0-.03-.04.04.05.01.01.03.04.04.07.04.13,0,.15-.02.28-.04.41-.03.15-.06.3-.09.45-.07.29-.17.58-.29.84-.14.31-.31.61-.51.9l.35-.05c-.21-.21-.37-.41-.52-.66s-.28-.5-.37-.75c-.1-.27-.17-.56-.21-.85,0,.03,0-.02,0-.03,0-.02,0-.03,0-.05,0-.03,0-.07,0-.1s0-.07,0-.11,0-.08,0-.1,0-.03.01-.05c.01-.04-.01.02,0-.01,0,0,.03-.04.01-.02-.01.02.03-.02,0,0-.02.01.02-.01.02-.01.03-.01-.02,0,0,0s0,0-.01,0c0,0,.01,0,.02,0,.03.02-.02-.02.01,0,.02.01.03.03.04.04.03.03.06.07.09.1.05.06.09.12.14.19.1.15.2.31.28.47.05.11.21.14.31.08.11-.06.14-.2.08-.31-.08-.17-.18-.33-.29-.48s-.21-.3-.34-.42c-.16-.14-.39-.19-.58-.06-.18.12-.25.32-.26.53,0,.18.02.36.05.54.03.16.06.33.11.49.1.33.23.66.4.96.19.34.43.65.7.93.11.11.27.07.35-.05.41-.59.71-1.26.87-1.97.04-.18.07-.37.1-.55s.05-.37-.02-.55c-.07-.19-.23-.35-.45-.37-.18-.02-.37.07-.51.18-.31.23-.51.6-.5.99,0,.12.1.22.22.22s.23-.1.22-.22h0Z"
      />
      <path
        className="cls-1"
        d="M2.25,5.19c-.3-.24-.42-.68-.29-1.04.02-.07.05-.13.11-.17.09-.08.23-.07.33-.03s.19.14.27.22c.61.67,1.04,1.5,1.26,2.38-.98.06-1.97-.24-2.75-.83-.09-.07-.19-.15-.24-.25s-.04-.25.04-.32c.07-.07.18-.07.28-.07.31,0,.61.05.91.12"
      />
      <path
        className="cls-1"
        d="M2.41,5.03s-.09-.09-.13-.14c.02.03,0,0,0,0,0-.01-.02-.02-.02-.04-.02-.03-.04-.07-.06-.1-.02-.03.01.03,0,0,0-.02-.01-.03-.02-.05,0-.03-.02-.05-.02-.08,0-.01,0-.03,0-.04,0,0,0-.07,0-.03s0-.04,0-.03c0-.02,0-.04,0-.05,0-.03,0-.06,0-.1,0-.05,0-.01,0,0,0-.01,0-.03,0-.04,0-.03.02-.07.03-.1,0,0,.02-.04,0-.01,0,0,.03-.06.01-.03,0,0,.02-.04,0-.01,0-.01.03-.02,0,0,.01,0,.03,0,.04-.01-.04,0,0,0,.02,0,.04,0-.04-.02.02,0,.01,0,.03,0,.04.01-.01,0-.02-.01.01,0,0,0,.05.04.04.02.12.09.22.22.31.33s.17.22.26.35c.17.25.32.52.45.8.07.14.12.27.18.44s.11.34.15.51l.22-.28c-.15,0-.3,0-.45,0-.07,0-.13,0-.2-.02-.03,0-.07,0-.1-.01.03,0-.02,0-.03,0-.02,0-.04,0-.06,0-.29-.05-.58-.13-.85-.23-.24-.09-.52-.24-.75-.4-.06-.04-.13-.09-.19-.13.02.02-.04-.03-.05-.04-.03-.03-.06-.05-.08-.08.02.02-.02-.04-.03-.05.02.04,0-.06,0,0,0-.01,0-.03,0-.04,0,.05.01,0,0,0-.02.02.02-.03,0,0-.02.02.03-.02,0,0-.03.02,0,0,.02,0,.01,0,.05,0,.02,0,.04,0,.08,0,.12,0,.1,0,.19,0,.29.02.18.02.36.05.53.1.11.03.25-.04.28-.16s-.04-.24-.16-.28c-.2-.05-.39-.09-.6-.11-.18-.02-.39-.04-.57,0-.22.04-.36.21-.38.43-.01.19.08.36.21.49.24.23.56.41.86.56.32.15.65.27,1,.34.38.08.77.12,1.16.09.15,0,.25-.14.22-.28-.17-.69-.47-1.36-.89-1.94-.11-.15-.22-.3-.35-.44-.13-.15-.27-.3-.45-.37s-.43-.05-.57.1c-.13.14-.18.34-.2.52-.04.36.12.76.4.99.09.08.23.09.32,0,.08-.08.09-.24,0-.32h0Z"
      />
      <path
        className="cls-1"
        d="M3.12,15.96c-.26-.28-.33-.73-.15-1.07.03-.06.07-.12.13-.16.1-.06.23-.04.34.02s.17.16.24.26c.51.75.84,1.62.94,2.52-.97-.07-1.92-.5-2.62-1.18-.08-.08-.17-.17-.2-.28s-.01-.25.08-.31c.08-.06.19-.05.28-.03.3.04.6.13.89.24"
      />
      <path
        className="cls-1"
        d="M3.28,15.8s-.02-.03-.03-.04c-.03-.03.03.04,0-.01-.02-.02-.03-.05-.04-.07-.02-.03-.03-.06-.05-.09,0,0,.01.04,0,0,0-.02-.01-.04-.02-.06,0-.03-.02-.06-.02-.09,0-.02,0-.03,0-.05,0,0,0,.04,0,0,0-.03,0-.06,0-.09,0-.02,0-.03,0-.05,0-.01,0-.07,0-.02,0-.06.03-.12.05-.18,0,0,.02-.04,0,0,0-.01.01-.02.02-.04,0-.02.02-.03.03-.05,0,0,.01-.02.02-.03-.01.02-.01.02,0,0,0,0,.04-.04,0-.01,0,0,.04-.02,0,0,.03-.01.02,0,0,0,0,0,.07,0,.04,0-.03,0,.04.01.04.01,0,0-.03-.02,0,0,.01,0,.03.02.04.02-.03-.02.02.02.03.02.06.06.07.07.11.14s.09.14.13.2c.08.13.16.27.23.4.03.07.07.13.1.2.03.07.06.14.08.19.06.14.11.28.15.43.05.16.09.33.13.5s.06.33.08.48l.22-.22c-.07,0-.14-.01-.21-.02.04,0-.03,0-.03,0-.02,0-.03,0-.05,0-.04,0-.08-.01-.11-.02-.14-.03-.29-.06-.43-.1-.29-.09-.51-.18-.77-.33-.13-.07-.25-.15-.37-.23s-.2-.14-.32-.25c-.05-.05-.1-.09-.15-.14-.03-.03-.06-.05-.08-.08-.01-.01-.02-.02-.03-.04.02.02-.02-.03-.02-.03,0-.01-.02-.03-.02-.04.01.03,0-.01,0-.02,0-.01,0-.05,0,0,0-.01,0-.03,0-.04,0,.05,0,0,0,0,0-.03-.02.04,0,0,0-.01.03-.03,0,0-.04.04.03-.02-.01,0,.02-.01.03,0,0,0,.02,0,.05,0,.07,0,0,0,.07,0,.04,0-.02,0,0,0,.02,0,.02,0,.03,0,.05,0,.09.01.17.03.26.05.19.05.37.11.55.18.11.04.25-.05.28-.16.03-.13-.04-.23-.16-.28-.18-.07-.36-.13-.55-.18-.17-.04-.37-.09-.55-.08-.22.02-.4.16-.44.39-.03.21.05.39.19.55.22.25.51.47.79.65s.6.33.92.45c.37.13.75.21,1.14.24.11,0,.24-.11.22-.22-.08-.73-.29-1.44-.64-2.09-.08-.16-.18-.31-.27-.46-.11-.16-.22-.33-.39-.42-.19-.11-.44-.11-.62.03-.13.11-.21.29-.25.46-.08.38.02.79.29,1.07.08.09.24.09.32,0,.09-.09.09-.23,0-.32h0Z"
      />
      <path
        className="cls-1"
        d="M13.27,20.28c.26-.28.71-.37,1.06-.21.06.03.13.07.17.12.07.1.06.23,0,.34s-.15.18-.24.25c-.72.55-1.57.92-2.47,1.06.02-.98.4-1.94,1.05-2.67.08-.09.16-.17.27-.22s.25-.02.32.07c.06.08.06.18.05.28-.03.31-.1.61-.2.9"
      />
      <path
        className="cls-1"
        d="M13.43,20.44s.05-.05.08-.07c-.03.03.03-.02.04-.03.03-.02.05-.03.08-.05.02,0,.03-.02.05-.02-.04.02.01,0,.02,0,.03,0,.05-.02.08-.02.02,0,.03,0,.05-.01.01,0,.06,0,.01,0,.07,0,.13,0,.2,0,.01,0,.06,0,.01,0,.01,0,.03,0,.04,0,.03,0,.05.01.08.02.02,0,.03.01.05.02.04.01-.05-.03.02,0,.01,0,.03.01.04.02.04.02,0-.01.03.02.04.04,0,.01,0,0-.02-.03,0,0,0,.02,0,.02.01-.03,0,.02,0,0,0,.04,0,0,0,.01,0,.03-.01.04.01-.03,0,0,0,0-.03.04-.02.04-.06.08-.1.11-.2.17-.33.26s-.26.17-.4.25c-.27.15-.53.27-.8.37-.32.12-.66.21-1,.26l.28.22c0-.31.04-.54.11-.84.04-.14.08-.29.13-.42.05-.15.09-.24.16-.38.06-.13.13-.26.21-.38.04-.06.08-.12.12-.18.02-.03.04-.06.06-.09.03-.04.03-.04.05-.07.04-.06.09-.11.14-.17.02-.03.05-.05.07-.08.03-.03.04-.04.06-.05.01,0,.03-.02.04-.02-.03.01,0,0,0,0,0,0,.06-.01.03,0s.03,0,.03,0c0,0-.05,0,0,0,.05.01,0,0,0,0h.02s-.02,0,0,0c.01.01,0,0,0,0v.02s0,0,0-.01c0,.02,0,.03,0,.01,0-.02,0,.04,0,.05,0,.04,0,.08,0,.12,0,.09-.02.15-.04.25-.04.19-.09.37-.15.55-.04.11.04.25.16.28.13.03.24-.04.28-.16.06-.18.11-.36.15-.55s.08-.38.06-.57c-.02-.21-.16-.39-.38-.43s-.39.05-.55.19c-.13.12-.24.27-.34.41s-.19.28-.28.42c-.17.3-.31.62-.41.96-.11.37-.17.76-.18,1.15,0,.16.15.24.28.22.7-.11,1.39-.37,2-.73.15-.09.3-.19.44-.29.15-.11.31-.23.4-.39.11-.2.11-.44-.04-.62-.11-.13-.31-.21-.48-.24-.38-.06-.78.05-1.06.33-.08.09-.09.23,0,.32s.23.09.32,0h0Z"
      />
      <path
        className="cls-1"
        d="M51.88,18.26c.26-.28.71-.37,1.06-.21.06.03.13.07.17.12.07.1.06.23,0,.34s-.15.18-.24.25c-.72.55-1.57.92-2.47,1.06.02-.98.4-1.94,1.05-2.67.08-.09.16-.17.27-.22s.25-.02.32.07c.06.08.06.18.05.28-.03.31-.1.61-.2.9"
      />
      <path
        className="cls-1"
        d="M52.04,18.42s.05-.05.08-.07c-.03.03.03-.02.04-.03.03-.02.05-.03.08-.05.02,0,.03-.02.05-.02-.04.02.01,0,.02,0,.03,0,.05-.02.08-.02.02,0,.03,0,.05-.01.01,0,.06,0,.01,0,.07,0,.13,0,.2,0,.01,0,.06,0,.01,0,.01,0,.03,0,.04,0,.03,0,.05.01.08.02.02,0,.03.01.05.02.04.01-.05-.03.02,0,.01,0,.03.01.04.02.04.02,0-.01.03.02.04.04,0,.01,0,0-.02-.03,0,0,0,.02,0,.02.01-.03,0,.02,0,0,0,.04,0,0,0,.01,0,.03-.01.04.01-.03,0,0,0,0-.03.04-.02.04-.06.08-.1.11-.2.17-.33.26s-.26.17-.4.25c-.27.15-.53.27-.8.37-.32.12-.66.21-1,.26l.28.22c0-.31.04-.54.11-.84.04-.14.08-.29.13-.42.05-.15.09-.24.16-.38.06-.13.13-.26.21-.38.04-.06.08-.12.12-.18.02-.03.04-.06.06-.09.03-.04.03-.04.05-.07.04-.06.09-.11.14-.17.02-.03.05-.05.07-.08.03-.03.04-.04.06-.05.01,0,.03-.02.04-.02-.03.01,0,0,0,0,0,0,.06-.01.03,0s.03,0,.03,0c0,0-.05,0,0,0,.05.01,0,0,0,0h.02s-.02,0,0,0c.01.01,0,0,0,0v.02s0,0,0-.01c0,.02,0,.03,0,.01,0-.02,0,.04,0,.05,0,.04,0,.08,0,.12,0,.09-.02.15-.04.25-.04.19-.09.37-.15.55-.04.11.04.25.16.28.13.03.24-.04.28-.16.06-.18.11-.36.15-.55s.08-.38.06-.57c-.02-.21-.16-.39-.38-.43s-.39.05-.55.19c-.13.12-.24.27-.34.41s-.19.28-.28.42c-.17.3-.31.62-.41.96-.11.37-.17.76-.18,1.15,0,.16.15.24.28.22.7-.11,1.39-.37,2-.73.15-.09.3-.19.44-.29.15-.11.31-.23.4-.39.11-.2.11-.44-.04-.62-.11-.13-.31-.21-.48-.24-.38-.06-.78.05-1.06.33-.08.09-.09.23,0,.32s.23.09.32,0h0Z"
      />
      <path
        className="cls-1"
        d="M73.72,13.66c.09-.37.43-.67.82-.71.07,0,.14,0,.2.02.11.05.16.17.17.29s-.04.23-.09.34c-.35.84-.91,1.58-1.62,2.15-.47-.86-.62-1.88-.42-2.84.02-.11.05-.23.13-.32s.2-.14.31-.1c.09.04.14.13.18.22.13.28.22.57.27.88"
      />
      <path
        className="cls-1"
        d="M73.94,13.72s.02-.06.03-.09c.01-.04,0-.02,0,0,0-.01.01-.03.02-.04.01-.03.03-.05.05-.08,0-.01.02-.03.03-.04-.02.03.02-.03.02-.03.09-.1.15-.15.28-.21-.03.01.05-.02.05-.02.03,0,.06-.02.09-.02.01,0,.03,0,.05,0-.01,0-.04,0,.01,0,.02,0,.03,0,.05,0h.03s-.01,0,0,0c.02,0,0,0,0,0,.01,0,.02.02.03.03-.01-.02,0-.01,0,0,0,0,0-.04,0,0,0,.01,0,.03.01.04,0-.01,0-.03,0,0s0,.06-.01.1c-.07.27-.23.55-.38.8s-.32.5-.51.72c-.22.26-.47.5-.73.71l.35.05c-.27-.5-.43-1.07-.46-1.63-.02-.28,0-.59.04-.85.02-.13.04-.29.1-.39.02-.03.01-.03.04-.04-.03.02.06-.03.02-.01,0,0,.04-.01,0,0,.01,0,.04,0,0,0,0,0-.01,0-.01,0,0-.01.03.02.03.03-.02-.02,0,.01,0,.01,0,.02.02.04.03.05.01.03.03.06.04.09.03.08.07.17.09.25.06.17.1.34.13.52.02.12.17.19.28.16.13-.03.18-.16.16-.28-.03-.18-.08-.36-.14-.53s-.12-.36-.22-.51c-.11-.18-.3-.27-.51-.23s-.33.21-.41.39c-.07.17-.09.35-.11.53-.02.17-.04.34-.04.51,0,.35.03.71.11,1.05.09.39.23.77.42,1.12.07.14.25.13.35.05.55-.45,1.02-1.01,1.37-1.63.09-.15.16-.31.23-.47.08-.18.17-.38.16-.59s-.13-.4-.33-.48c-.17-.07-.38-.03-.55.03-.36.14-.65.43-.75.81-.03.12.04.24.16.28s.25-.04.28-.16h0Z"
      />
      <path
        className="cls-1"
        d="M79.71,21.79c-.07-.38.12-.79.45-.98.06-.04.13-.06.2-.06.12,0,.22.09.27.2s.06.23.06.35c.03.9-.17,1.82-.57,2.63-.78-.59-1.35-1.46-1.56-2.41-.03-.11-.05-.23-.02-.35s.12-.22.24-.22c.1,0,.18.06.26.13.23.2.44.43.61.68"
      />
      <path
        className="cls-1"
        d="M79.93,21.73s0-.02,0,0c0-.01,0-.03,0-.04,0-.03,0-.06,0-.09,0-.01,0-.03,0-.04,0,0,0-.04,0,0,0-.03.01-.07.02-.1.02-.07.02-.08.05-.13.01-.02.02-.05.04-.07,0-.01.02-.03.02-.04,0,0,.04-.05.02-.03.04-.05.08-.09.13-.13-.02.02.03-.02.04-.02.02-.01.07-.04.07-.04.02,0,.03-.01.05-.01-.01,0-.01,0-.02,0,.01,0,.03,0,.04.01-.04-.02,0,0,0,0-.03-.04.04.05.01.01.02.02.03.05.04.07.04.12.03.28.03.42,0,.15,0,.3-.02.46-.03.3-.08.6-.16.9-.09.33-.21.65-.36.96l.31-.08c-.08-.06-.21-.17-.3-.25-.11-.1-.21-.21-.3-.32-.18-.21-.33-.43-.47-.68s-.23-.48-.32-.75c-.04-.13-.09-.28-.09-.41,0-.04,0-.05,0-.08,0-.04,0-.02,0,0,0-.01.01-.03.02-.04-.02.03,0,0,0,0-.04.02.01-.02,0,0,0,.01.02,0,0,0-.02,0-.02,0,0,0-.03,0,0,0,.01,0,0,0,.06.03.04.02.04.03.07.06.1.09.06.06.12.11.18.17.12.13.24.26.34.41.07.1.2.15.31.08.1-.06.15-.21.08-.31-.11-.16-.23-.31-.37-.46-.13-.14-.27-.28-.42-.38-.19-.12-.42-.1-.58.05s-.19.38-.15.6c.05.34.18.67.32.97s.33.61.54.88c.24.31.52.57.83.81.09.07.26.02.31-.08.34-.68.54-1.41.59-2.17.01-.19.02-.37.01-.56s-.03-.39-.14-.55c-.13-.17-.32-.26-.53-.22-.16.03-.32.15-.44.27-.27.28-.38.67-.31,1.05.02.12.17.19.28.16.13-.03.18-.16.16-.28h0Z"
      />
    </g>
  </svg>
);

export const Title = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    id="Camada_1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    {...props}
  >
    <defs>
      <style>
        {".cls-1{fill:#fffff;}.cls-2{opacity:.125;}.cls-3{fill:#F2C94C;}"}
      </style>
    </defs>
    <path
      className=" cls-3"
      d="M3.12,14.32s0,.02,0,.05c.15-.03.75-1.09.86-1.29.44-.81,1.21-2.09,1.78-2.12.19,0,.19.15.37.19.22.06.34.2.35.44.03.68-.77,1.89-.99,2.54.35-.13.93-.51,1.53-1.5.05-.08.09-.13.12-.13.06,0,.05.15.24.19.13.03.2.11.21.22,0,.04,0,.09-.03.13-.06.14-.58.92-1.16,1.34-.2.15-.47.24-.72.26-.44.02-.75-.21-.77-.61-.01-.27.11-.6.31-.93.52-.89.64-1.29.68-1.52-.32.15-.99,1.24-1.1,1.42-.36.56-.95,1.65-1.55,1.68-.08,0-.22-.05-.36-.1-.28-.1-.39-.26-.4-.47-.03-.62,1-1.86,1.11-2.4-.48.22-.97.94-1.3,1.45-.76,1.19-.76,1.75-.91,1.76-.07,0-.11-.06-.24-.06-.09,0-.25-.08-.25-.23-.02-.36.76-1.99.89-2.21.04-.06.06-.1.1-.1.04,0,.09.02.19.08.35-.46.89-1.31,1.37-1.33.1,0,.2.06.28.18.01.03.04.04.08.05.22.06.36.24.37.52.02.72-1.07,1.94-1.05,2.49Z"
    />
    <path
      className=" cls-3"
      d="M9,11.02c.03.06.05.07.1.09.26.08.43.32.44.6.03.54-.55,1.29-1.16,1.32-.37.02-.59-.12-.7-.19-.1.17-.21.55-.2.82.02.32.21.41.56.4.69-.03,1.36-.53,1.99-1.56.05-.08.09-.13.12-.13.06,0,.05.15.24.19.13.03.19.11.2.22,0,.16-.53.98-1.2,1.48-.32.23-.61.31-1.13.34-.22.01-.42-.11-.6-.2-.25-.12-.79-.28-.82-.96s.38-1.54.81-2.02c.23-.26.6-.57.95-.59.18,0,.31.06.39.19ZM8.89,11.54h-.02c-.52.18-1,.87-1.1,1.09.04.02.14.03.24.03.29-.01.54-.26.67-.48.06-.1.24-.48.23-.6,0-.03,0-.04-.03-.04Z"
    />
    <path
      className=" cls-3"
      d="M12.1,9.92c-.33.5-.57.91-.76,1.26-.13.23-.41.87-.61,1.32-.25.57-.36,1.26-.17,1.43.37-.02,1.13-.55,1.74-1.55.05-.08.09-.13.12-.13.06,0,.05.15.23.19.14.03.2.11.2.22,0,.04,0,.09-.03.13-.09.2-1.04,1.55-1.89,1.59-.3.01-.43,0-.61-.11-.36-.14-.51-.42-.52-.78-.04-.74.49-1.8.84-2.53.46-.98.92-1.96,1.43-2.89.19-.35.3-.51.39-.52s.08.15.31.17c.22.02.32.13.32.3.02.39-.48,1.11-1,1.89Z"
    />
    <path
      className=" cls-3"
      d="M14.57,9.79c-.37.56-1.02,1.4-1.33,1.86.88-.9,1.28-1.12,1.53-1.13.22-.01.23.2.36.23.23.06.44.27.45.56.02.37-.23.96-.71,1.83-.13.24-.23.46-.22.59,0,.02,0,.03.01.05.34-.11.99-.58,1.61-1.6.05-.08.09-.13.12-.13.06,0,.05.15.24.19.14.03.19.11.2.22,0,.04,0,.09-.03.13-.09.2-1.04,1.55-1.69,1.59-.43.02-.52-.09-.6-.12-.33-.09-.45-.27-.47-.51-.02-.33.21-.76.44-1.15.25-.44.41-.85.4-1.1,0-.06-.02-.11-.04-.15h-.05c-.38.02-1.37.74-2.41,2.76-.17.33-.13.47-.23.47-.06,0-.11-.05-.17-.06-.15-.02-.32-.11-.33-.23-.02-.39.52-1.49,1.07-2.64.38-.79,1.07-2.32,1.83-3.51.22-.35.31-.51.4-.51.08,0,.07.14.3.17.22.02.32.13.32.3.02.39-.51,1.11-1.03,1.89Z"
    />
    <path
      className=" cls-3"
      d="M16.75,13.61c.25-.04.87-.35,1.22-1.17-.02-.08-.02-.15-.03-.24-.02-.44.13-1.33.36-1.37.03,0,.05,0,.07,0,.07,0,.15-.11.23-.12.12,0,.22.35.23.62.02.35-.07.76-.21,1.14.08.08.18.13.28.12.2-.01.43-.2.64-.53.05-.08.09-.12.12-.13.07,0,.05.15.23.19.13.03.19.11.2.22,0,.04,0,.09-.03.14-.28.52-.69.8-1.11.82-.23.01-.45-.06-.63-.21-.35.58-.81,1.02-1.22,1.05-.08,0-.19-.02-.26-.05-.15-.07-.22-.03-.51-.34-.18-.18-.25-.42-.26-.67-.04-.85.65-1.98,1.09-2.46.11-.12.22-.23.33-.23.05,0,.11.02.16.08.03.04.07.1.14.1h0c.07,0,.11.03.12.1,0,.08-.04.21-.16.41-.07.12-.37.56-.64,1.05-.32.58-.39,1.02-.38,1.27,0,.1.02.16.04.2Z"
    />
    <path
      className=" cls-3"
      d="M20.38,10.41c-.24-.22-.31-.4-.32-.54,0-.18.12-.3.2-.31.1,0,.27.12.59.41.28.25.2.37.79.61.24.1.35.25.36.47.02.34-.22.76-.41,1.08-.05.09-.53.82-.51,1.18,0,.03,0,.05.02.08.34-.11.9-.52,1.52-1.53.05-.08.09-.13.12-.13.06,0,.05.15.23.19.14.03.19.11.2.22,0,.04,0,.09-.03.13-.09.2-1.03,1.55-1.68,1.59-.44.02-.54-.1-.59-.12-.25-.05-.37-.34-.38-.58-.01-.28.11-.65.56-1.45.14-.25.4-.78.41-.84,0-.01-.44-.14-.45-.14-.46,1.01-1.16,2.22-1.38,2.23-.03,0-.05,0-.08-.02-.06-.02-.34-.1-.35-.29,0-.17.57-.76,1.18-2.25Z"
    />
    <path
      className=" cls-3"
      d="M2.85,18.97c-.01-.27.17-.57.26-.72-.21.19-.66.76-1,1.07-.32.28-.51.34-.64.35s-.21-.04-.3-.06c-.23-.04-.33-.18-.34-.39-.04-.79,1.29-2.47,1.86-2.5.18,0,.15.13.28.17.1.03.16.09.16.17,0,.06,0,.09-.13.1-.25.02-.68.42-1.07.93-.49.63-.59.98-.59,1.16.09-.05.37-.22.86-.79.66-.77,1.07-1.08,1.18-1.08.08,0,.05.14.17.17.14.03.21.13.22.26.02.39-.53,1.08-.52,1.35,0,.02,0,.03,0,.04.27-.09.77-.45,1.26-1.26.04-.07.07-.1.09-.1.05,0,.04.12.18.15.11.02.14.09.14.17,0,.03,0,.07-.02.1-.07.15-.79,1.22-1.3,1.24-.14,0-.32,0-.45-.09-.2-.07-.32-.26-.33-.45Z"
    />
    <path
      className=" cls-3"
      d="M5.78,19.06s0,.01,0,.04c.12-.03.59-.86.67-1.01.34-.63.95-1.64,1.4-1.66.15,0,.15.12.29.15.17.05.27.16.28.35.03.53-.61,1.48-.77,1.99.27-.1.73-.4,1.2-1.18.04-.07.07-.1.09-.1.05,0,.04.12.19.15.1.02.16.09.16.17,0,.03,0,.07-.02.1-.05.11-.46.72-.91,1.05-.16.11-.37.19-.57.2-.34.02-.59-.17-.6-.48-.01-.21.08-.47.24-.73.41-.7.5-1.01.53-1.19-.25.12-.78.97-.87,1.11-.28.44-.75,1.29-1.22,1.31-.07,0-.17-.04-.28-.08-.22-.08-.31-.21-.32-.37-.02-.49.79-1.46.87-1.88-.38.18-.76.74-1.02,1.14-.6.93-.59,1.37-.72,1.38-.05,0-.08-.05-.19-.05-.07,0-.19-.07-.2-.18-.01-.28.6-1.56.7-1.73.03-.05.04-.08.08-.08.03,0,.07.02.15.07.27-.36.69-1.03,1.07-1.05.08,0,.16.04.22.14.01.02.03.03.06.04.17.05.28.19.29.41.02.57-.84,1.52-.82,1.95Z"
    />
    <path
      className=" cls-3"
      d="M9.17,18.77s.01.08.03.1c.27-.09.7-.4,1.19-1.2.04-.07.07-.1.09-.1.05,0,.04.12.19.15.11.02.16.09.16.17,0,.03,0,.07-.02.1-.07.15-.82,1.22-1.32,1.24-.15,0-.32,0-.45-.09-.27-.09-.37-.31-.38-.57-.03-.57.38-1.48.68-2.02.06-.11.08-.15.12-.15.05,0,.16.1.28.11.12.01.19.08.2.18,0,.18-.35.94-.56,1.26-.05.11-.21.6-.2.83ZM10.24,15.07h.01c.09,0,.18.06.19.2.01.26-.22.67-.34.8-.04.04-.09.06-.14.06-.15,0-.34-.11-.34-.22,0-.19.29-.74.33-.79.07-.1.12-.14.15-.14.05,0,.08.08.14.08Z"
    />
    <path
      className=" cls-3"
      d="M11.35,18.02c.66-.77,1.07-1.08,1.18-1.08.08,0,.05.14.17.17.14.03.21.13.22.26,0,.1-.03.23-.09.37-.18.46-.54,1.09-.97,1.83.58-.54,1.34-1.51,1.64-2,.04-.07.07-.1.09-.1.05,0,.04.12.19.15.11.02.16.09.17.18,0,.03,0,.07-.03.1-.69,1.08-1.87,2.18-2.89,3.33-.19.22-.31.51-.39.52-.06,0-.05-.11-.24-.13-.16-.02-.25-.11-.26-.24-.02-.36.44-.62.95-1.23.07-.17.96-1.92,1.17-2.35-.22.2-.69.79-1.03,1.1-.32.28-.51.34-.64.35s-.21-.04-.3-.06c-.23-.04-.33-.18-.34-.39-.04-.79,1.29-2.47,1.86-2.5.18,0,.15.13.28.17.1.03.16.09.16.17,0,.07-.01.09-.13.1-.25.02-.68.42-1.07.93-.49.63-.59.98-.59,1.16.09-.05.37-.22.86-.79Z"
    />
    <path
      className=" cls-3"
      d="M13.92,18.62c.2-.03.68-.28.95-.92-.01-.06-.02-.12-.02-.19-.02-.35.1-1.05.28-1.07.02,0,.04,0,.05,0,.05,0,.12-.09.18-.09.09,0,.17.28.18.49.01.28-.05.59-.17.9.06.07.14.1.22.1.16,0,.34-.15.5-.42.04-.07.07-.1.1-.1.05,0,.04.12.18.15.1.03.15.09.16.17,0,.03,0,.07-.03.11-.22.4-.54.63-.87.64-.18,0-.36-.05-.5-.17-.27.46-.63.8-.96.82-.06,0-.15-.01-.21-.04-.11-.05-.17-.02-.4-.27-.14-.14-.2-.33-.21-.53-.03-.67.51-1.55.85-1.93.09-.09.18-.18.26-.18.04,0,.09.01.12.06.03.04.06.08.11.08h0c.05,0,.09.02.09.08,0,.06-.03.17-.12.32-.06.09-.29.44-.5.82-.25.45-.31.8-.3,1,0,.08.02.13.03.16Z"
    />
    <path
      className=" cls-3"
      d="M18.93,19.65c.1.13.2.25.32.36.04.04.1.08.16.06.06-.02.06-.1.09-.15.03-.06.08-.11.11-.17.04-.08.04-.18,0-.26s-.09-.16-.15-.22c-.14-.15-.31-.28-.48-.39-.38-.27-.77-.53-1.17-.78-.05-.03-.11-.07-.17-.07-.11,0-.2.09-.27.19-.04.06-.09.12-.09.19,0,.08.04.17.1.22s.14.09.22.13c.62.31,1.19.74,1.67,1.25"
    />
    <path
      className=" cls-3"
      d="M17.71,17.32c-.06.05-.07.16-.02.23.03.04.08.06.12.08.1.04.21.07.32.09.3.08.59.15.89.23.15.04.29.08.44.1.23.04.46.07.69.08.39.03.78.04,1.16.01.08,0,.16-.01.22-.06.02-.01.04-.03.04-.06,0-.02,0-.04,0-.06,0-.07.07-.12.1-.19.03-.08-.02-.18-.09-.23s-.16-.06-.25-.06c-.28-.01-.56.03-.84.04-.9.04-1.78-.23-2.67-.32-.02,0-.04,0-.06,0-.05.03-.04.11-.08.15"
    />
    <path
      className=" cls-3"
      d="M17.45,16.73c-.1-.09-.13-.24-.09-.36.01-.03.02-.06.04-.08.09-.12.26-.16.41-.19.44-.11.82-.37,1.2-.62.04-.02.08-.05.12-.05s.1.02.1.07c.01.07-.07.13-.04.19,0,.02.03.03.04.05.06.06.08.17.05.25s-.09.16-.16.21c-.07.05-.15.09-.23.13-.37.18-.74.37-1.14.46-.06.01-.12.02-.18.02s-.12-.04-.15-.09"
    />
    <path
      className=" cls-3"
      d="M3.55,2.27c.22-.01.41,0,.57.04.16.04.29.09.39.16.1.07.18.17.24.28.05.11.08.23.09.37,0,.11,0,.22-.03.33-.03.11-.07.2-.13.29-.06.09-.14.17-.23.25-.1.07-.21.14-.35.19.23.05.4.13.52.25.12.12.18.28.19.48,0,.18-.02.36-.08.52-.06.16-.15.3-.27.42-.12.12-.27.22-.46.29-.18.07-.39.12-.62.13l-1.4.07.3-4,1.28-.06ZM3.41,5.71c.13,0,.24-.03.33-.07.09-.04.16-.09.22-.16.06-.07.1-.14.12-.23.02-.09.03-.19.03-.3,0-.14-.06-.26-.15-.34-.1-.08-.25-.12-.46-.11l-.67.03-.09,1.2.68-.03ZM2.94,2.85l-.09,1.19.53-.03c.25-.01.43-.08.56-.2.13-.12.19-.3.17-.54,0-.17-.06-.29-.16-.36-.1-.07-.25-.1-.45-.09l-.57.03Z"
    />
    <path
      className=" cls-3"
      d="M7.76,3.23l-.2,2.84-.34.02c-.16,0-.25-.07-.25-.22v-.33c-.13.21-.28.37-.45.47-.16.11-.34.17-.52.17-.12,0-.22-.01-.32-.06s-.18-.11-.24-.2-.11-.2-.14-.33c-.03-.13-.04-.28-.03-.46l.12-1.8.68-.03-.12,1.8c-.01.19,0,.32.05.4.05.08.13.11.24.11.07,0,.15-.03.22-.07.07-.04.15-.11.21-.18.07-.08.13-.17.18-.28.06-.11.1-.23.13-.36l.1-1.46.68-.03Z"
    />
    <path
      className=" cls-3"
      d="M9.96,3.65s-.04.05-.05.06c-.02.01-.04.02-.07.02-.03,0-.07,0-.1-.02-.03-.02-.07-.04-.12-.06-.04-.02-.09-.04-.15-.05-.06-.02-.12-.02-.2-.02-.14,0-.25.05-.33.11-.07.07-.11.15-.1.25,0,.08.03.13.09.18.06.04.13.08.21.11.08.03.17.06.27.09.1.03.19.07.27.12.09.05.16.12.22.2.06.08.09.19.1.32s-.01.27-.06.39c-.05.13-.12.24-.22.33-.1.1-.21.18-.35.24-.14.06-.3.1-.48.1-.09,0-.17,0-.26-.01-.09-.01-.16-.03-.24-.06-.07-.03-.14-.06-.2-.1-.06-.04-.12-.08-.16-.13l.16-.27s.04-.06.07-.08c.03-.02.06-.03.1-.03s.07,0,.11.03c.03.02.07.05.11.07.04.03.09.05.16.07.06.02.14.03.23.02.08,0,.14-.02.2-.04.06-.02.1-.05.14-.09.04-.04.07-.08.08-.13.02-.05.03-.1.02-.15,0-.06-.02-.11-.05-.15-.03-.04-.08-.07-.13-.1s-.11-.05-.18-.07c-.07-.02-.14-.04-.21-.06-.07-.02-.14-.05-.21-.08-.07-.03-.13-.07-.18-.12-.05-.05-.1-.11-.13-.18-.03-.07-.05-.16-.06-.26,0-.12.01-.25.05-.37.04-.12.11-.23.19-.32.09-.1.2-.17.33-.24.13-.06.29-.1.46-.11s.34.01.48.07c.14.05.26.13.36.22l-.16.26Z"
    />
    <path
      className=" cls-3"
      d="M12.32,5.59c-.08.07-.17.13-.25.18-.09.05-.18.08-.27.1-.1.02-.2.04-.32.04-.16,0-.31-.01-.44-.06-.13-.05-.25-.12-.34-.22-.09-.1-.17-.22-.22-.36-.05-.14-.09-.3-.1-.48,0-.15,0-.3.03-.45.03-.15.07-.29.12-.42.06-.13.13-.25.21-.36.08-.11.18-.21.28-.29.11-.08.22-.15.35-.2.13-.05.26-.08.41-.08.19,0,.35.02.48.08.13.06.26.15.36.28l-.2.27s-.03.03-.05.05c-.02.01-.04.02-.07.02-.03,0-.06,0-.09-.02-.03-.02-.06-.04-.09-.06-.04-.02-.08-.04-.13-.06s-.12-.02-.2-.02c-.1,0-.2.04-.3.1-.09.06-.17.15-.24.25s-.12.24-.16.39c-.04.15-.05.31-.04.49.01.21.06.37.16.47.1.11.22.16.38.15.07,0,.13-.01.18-.03.05-.02.1-.04.14-.06.04-.02.08-.05.11-.07.03-.03.06-.05.08-.07.03-.02.05-.04.08-.06.02-.02.05-.02.08-.03.02,0,.05,0,.07.01.02.01.04.03.06.04l.18.2c-.09.11-.17.2-.26.27Z"
    />
    <path
      className=" cls-3"
      d="M14.53,5.13c-.12.2-.25.36-.4.48-.15.12-.32.19-.5.2-.11,0-.21-.01-.3-.05-.09-.04-.18-.1-.25-.18-.07-.08-.13-.18-.18-.31-.05-.12-.07-.27-.08-.44s0-.33.04-.5c.03-.16.09-.31.16-.46.07-.14.16-.28.26-.4.1-.12.22-.23.36-.32.13-.09.28-.16.43-.22.16-.05.32-.09.5-.09.13,0,.25,0,.38,0,.13.01.25.04.38.08l-.2,2.76-.36.02c-.09,0-.15-.01-.18-.06-.03-.04-.05-.09-.05-.16v-.36ZM14.63,3.34s-.05,0-.07,0c-.02,0-.05,0-.07,0-.15,0-.29.05-.42.13-.13.08-.23.18-.32.3-.09.12-.16.26-.2.42-.05.16-.07.33-.06.5,0,.2.05.34.11.43.07.09.15.13.26.13.08,0,.15-.03.22-.09.07-.06.14-.13.2-.22s.12-.2.16-.33c.05-.13.09-.26.12-.4l.07-.86Z"
    />
    <path
      className=" cls-3"
      d="M2.76,9.97c-.12,0-.22,0-.33-.04-.1-.03-.19-.09-.27-.16-.08-.07-.14-.16-.18-.27-.05-.11-.07-.23-.08-.37,0-.18.01-.35.06-.51.05-.16.12-.3.22-.42.09-.12.21-.22.34-.29.13-.07.27-.11.42-.12.12,0,.23,0,.33.04.1.03.19.09.27.16.08.07.14.16.18.27.05.11.07.23.08.37,0,.18-.01.35-.06.51-.05.16-.12.3-.22.42-.09.12-.21.22-.34.29-.13.07-.27.11-.42.12ZM2.79,9.58c.08,0,.16-.03.23-.08.07-.05.12-.12.16-.2.04-.08.08-.18.1-.29.02-.11.03-.22.02-.34,0-.17-.04-.3-.1-.37-.06-.08-.15-.11-.27-.11-.08,0-.16.03-.23.08-.07.05-.12.12-.17.2-.04.08-.08.18-.1.29-.02.11-.03.22-.02.34,0,.17.04.3.1.37.06.08.15.11.27.11Z"
    />
    <path
      className=" cls-3"
      d="M5.13,9.39v-.03s0-.03,0-.06c0-.03,0-.06,0-.1,0-.04,0-.1.01-.16l.07-.95h-.2s-.05,0-.06-.01c-.02-.02-.02-.04-.02-.08v-.2s.33-.07.33-.07l.14-.58s.02-.05.04-.07c.02-.02.04-.02.07-.03h.27s-.05.65-.05.65l.51-.02-.03.36-.51.03-.07.92c0,.06,0,.1,0,.13,0,.03,0,.06,0,.08,0,.02,0,.03,0,.04v.02c0,.05.02.09.04.12.03.03.06.04.11.04.03,0,.05,0,.07-.01.02,0,.04-.02.05-.03.01,0,.03-.02.04-.03.01,0,.02-.01.03-.01.02,0,.03,0,.04,0,0,0,.02.02.02.03l.12.24c-.07.07-.15.12-.24.15-.09.04-.18.06-.28.06-.15,0-.27-.03-.36-.1-.09-.08-.14-.19-.15-.33Z"
    />
    <path
      className=" cls-3"
      d="M6.89,8.87c.02.33.16.49.45.48.06,0,.11-.01.16-.03.05-.01.09-.03.12-.05.03-.02.06-.04.09-.06.03-.02.05-.04.08-.06.02-.02.05-.03.07-.05.02-.01.05-.02.08-.02.02,0,.03,0,.05,0,.02,0,.03.02.04.03l.14.15c-.07.08-.14.14-.2.2-.07.06-.14.1-.21.14-.07.04-.15.07-.23.09-.08.02-.17.03-.26.04-.12,0-.24,0-.34-.05-.1-.04-.19-.09-.27-.16-.07-.07-.13-.16-.18-.27-.04-.11-.07-.22-.08-.36,0-.11,0-.22.02-.33.02-.11.05-.21.09-.31.04-.1.09-.19.15-.27.06-.08.13-.16.21-.22.08-.06.17-.11.27-.15.1-.04.2-.06.32-.06s.21,0,.29.03c.08.03.16.06.21.11.06.05.1.1.13.16.03.06.05.12.05.18,0,.09,0,.18-.04.26-.03.08-.1.15-.19.22-.09.07-.22.13-.39.18-.16.05-.38.1-.63.14v.03ZM7.44,7.92c-.07,0-.13.02-.19.05-.06.03-.11.07-.15.13-.04.05-.08.12-.11.19-.03.07-.06.15-.07.24.17-.03.3-.06.41-.1.1-.03.18-.07.23-.1.05-.03.09-.07.11-.11.02-.04.02-.08.02-.12,0-.02,0-.04-.02-.06-.01-.02-.02-.04-.04-.06-.02-.02-.04-.03-.07-.04-.03-.01-.07-.01-.11-.01Z"
    />
    <path
      className=" cls-3"
      d="M10.34,7.45l-.15,2.12h-.26c-.12.02-.18-.04-.19-.15v-.24c-.1.16-.21.27-.33.35-.12.08-.25.12-.39.13-.09,0-.17,0-.24-.04s-.13-.08-.18-.15-.08-.15-.11-.25c-.02-.1-.03-.21-.02-.34l.09-1.34.51-.02-.09,1.34c-.01.14,0,.24.04.3.03.06.09.08.18.08.05,0,.11-.02.17-.05.06-.03.11-.08.16-.14.05-.06.1-.13.14-.21.04-.08.07-.17.1-.27l.08-1.09.51-.02Z"
    />
  </svg>
);
